var map = {
	"./carriers/40x40/0B.png": 41020,
	"./carriers/40x40/0J.png": 598708,
	"./carriers/40x40/0N.png": 891120,
	"./carriers/40x40/0T.png": 546746,
	"./carriers/40x40/0V.png": 62696,
	"./carriers/40x40/1I.png": 39432,
	"./carriers/40x40/1X.png": 358465,
	"./carriers/40x40/2A.png": 556893,
	"./carriers/40x40/2B.png": 775686,
	"./carriers/40x40/2C.png": 814703,
	"./carriers/40x40/2D.png": 702480,
	"./carriers/40x40/2F.png": 368994,
	"./carriers/40x40/2G.png": 590123,
	"./carriers/40x40/2H.png": 64284,
	"./carriers/40x40/2I.png": 147173,
	"./carriers/40x40/2J.png": 893166,
	"./carriers/40x40/2K.png": 322391,
	"./carriers/40x40/2L.png": 589752,
	"./carriers/40x40/2M.png": 810881,
	"./carriers/40x40/2N.png": 780298,
	"./carriers/40x40/2O.png": 935507,
	"./carriers/40x40/2P.png": 84836,
	"./carriers/40x40/2Q.png": 127341,
	"./carriers/40x40/2R.png": 736662,
	"./carriers/40x40/2S.png": 998399,
	"./carriers/40x40/2T.png": 139744,
	"./carriers/40x40/2U.png": 110921,
	"./carriers/40x40/2V.png": 745778,
	"./carriers/40x40/2W.png": 494779,
	"./carriers/40x40/2Y.png": 497781,
	"./carriers/40x40/2Z.png": 895678,
	"./carriers/40x40/3A.png": 594934,
	"./carriers/40x40/3B.png": 26701,
	"./carriers/40x40/3C.png": 363460,
	"./carriers/40x40/3D.png": 18267,
	"./carriers/40x40/3E.png": 696722,
	"./carriers/40x40/3F.png": 244905,
	"./carriers/40x40/3G.png": 120704,
	"./carriers/40x40/3H.png": 564935,
	"./carriers/40x40/3J.png": 225877,
	"./carriers/40x40/3K.png": 314252,
	"./carriers/40x40/3L.png": 363651,
	"./carriers/40x40/3M.png": 773818,
	"./carriers/40x40/3N.png": 433713,
	"./carriers/40x40/3O.png": 985320,
	"./carriers/40x40/3P.png": 290767,
	"./carriers/40x40/3Q.png": 5670,
	"./carriers/40x40/3R.png": 589437,
	"./carriers/40x40/3S.png": 368308,
	"./carriers/40x40/3T.png": 660299,
	"./carriers/40x40/3U.png": 896642,
	"./carriers/40x40/3V.png": 410649,
	"./carriers/40x40/3W.png": 694896,
	"./carriers/40x40/3X.png": 68727,
	"./carriers/40x40/3Z.png": 797509,
	"./carriers/40x40/4A.png": 8603,
	"./carriers/40x40/4B.png": 111040,
	"./carriers/40x40/4C.png": 235241,
	"./carriers/40x40/4D.png": 585270,
	"./carriers/40x40/4E.png": 639071,
	"./carriers/40x40/4F.png": 353796,
	"./carriers/40x40/4G.png": 17037,
	"./carriers/40x40/4H.png": 764154,
	"./carriers/40x40/4I.png": 353987,
	"./carriers/40x40/4J.png": 975656,
	"./carriers/40x40/4K.png": 424049,
	"./carriers/40x40/4L.png": 379486,
	"./carriers/40x40/4M.png": 555271,
	"./carriers/40x40/4N.png": 304588,
	"./carriers/40x40/4O.png": 216213,
	"./carriers/40x40/4R.png": 685232,
	"./carriers/40x40/4S.png": 400985,
	"./carriers/40x40/4T.png": 996006,
	"./carriers/40x40/4U.png": 281103,
	"./carriers/40x40/4V.png": 358644,
	"./carriers/40x40/4W.png": 579773,
	"./carriers/40x40/4X.png": 803178,
	"./carriers/40x40/4Y.png": 653939,
	"./carriers/40x40/4Z.png": 479448,
	"./carriers/40x40/5A.png": 811060,
	"./carriers/40x40/5B.png": 733519,
	"./carriers/40x40/5C.png": 448422,
	"./carriers/40x40/5D.png": 853401,
	"./carriers/40x40/5E.png": 137648,
	"./carriers/40x40/5F.png": 103051,
	"./carriers/40x40/5G.png": 339394,
	"./carriers/40x40/5H.png": 240261,
	"./carriers/40x40/5I.png": 922748,
	"./carriers/40x40/5J.png": 511479,
	"./carriers/40x40/5K.png": 521486,
	"./carriers/40x40/5L.png": 204577,
	"./carriers/40x40/5M.png": 931864,
	"./carriers/40x40/5N.png": 106355,
	"./carriers/40x40/5O.png": 255594,
	"./carriers/40x40/5P.png": 469453,
	"./carriers/40x40/5Q.png": 806212,
	"./carriers/40x40/5R.png": 91487,
	"./carriers/40x40/5S.png": 37686,
	"./carriers/40x40/5T.png": 687657,
	"./carriers/40x40/5U.png": 563456,
	"./carriers/40x40/5V.png": 461019,
	"./carriers/40x40/5W.png": 139474,
	"./carriers/40x40/5X.png": 668629,
	"./carriers/40x40/5Y.png": 757004,
	"./carriers/40x40/5Z.png": 524039,
	"./carriers/40x40/6A.png": 12161,
	"./carriers/40x40/6B.png": 854730,
	"./carriers/40x40/6C.png": 586643,
	"./carriers/40x40/6D.png": 689244,
	"./carriers/40x40/6E.png": 925157,
	"./carriers/40x40/6F.png": 213678,
	"./carriers/40x40/6G.png": 913175,
	"./carriers/40x40/6H.png": 996816,
	"./carriers/40x40/6I.png": 486713,
	"./carriers/40x40/6J.png": 20130,
	"./carriers/40x40/6K.png": 910635,
	"./carriers/40x40/6L.png": 960724,
	"./carriers/40x40/6M.png": 181853,
	"./carriers/40x40/6N.png": 884294,
	"./carriers/40x40/6O.png": 465839,
	"./carriers/40x40/6P.png": 812360,
	"./carriers/40x40/6Q.png": 322577,
	"./carriers/40x40/6R.png": 901466,
	"./carriers/40x40/6S.png": 665571,
	"./carriers/40x40/6V.png": 639486,
	"./carriers/40x40/6W.png": 391975,
	"./carriers/40x40/6Y.png": 185353,
	"./carriers/40x40/6Z.png": 854386,
	"./carriers/40x40/7A.png": 94330,
	"./carriers/40x40/7B.png": 24497,
	"./carriers/40x40/7C.png": 610280,
	"./carriers/40x40/7D.png": 401799,
	"./carriers/40x40/7E.png": 683486,
	"./carriers/40x40/7F.png": 850837,
	"./carriers/40x40/7G.png": 965388,
	"./carriers/40x40/7H.png": 219547,
	"./carriers/40x40/7I.png": 321682,
	"./carriers/40x40/7J.png": 412393,
	"./carriers/40x40/7K.png": 441216,
	"./carriers/40x40/7L.png": 392543,
	"./carriers/40x40/7M.png": 796214,
	"./carriers/40x40/7O.png": 437892,
	"./carriers/40x40/7P.png": 288563,
	"./carriers/40x40/7Q.png": 133354,
	"./carriers/40x40/7R.png": 82337,
	"./carriers/40x40/7S.png": 597720,
	"./carriers/40x40/7T.png": 389239,
	"./carriers/40x40/7U.png": 246222,
	"./carriers/40x40/7V.png": 118021,
	"./carriers/40x40/7W.png": 588604,
	"./carriers/40x40/7Y.png": 971074,
	"./carriers/40x40/7Z.png": 519257,
	"./carriers/40x40/8B.png": 403476,
	"./carriers/40x40/8C.png": 624605,
	"./carriers/40x40/8D.png": 462882,
	"./carriers/40x40/8E.png": 353387,
	"./carriers/40x40/8F.png": 439568,
	"./carriers/40x40/8G.png": 445817,
	"./carriers/40x40/8H.png": 656430,
	"./carriers/40x40/8I.png": 355927,
	"./carriers/40x40/8J.png": 131996,
	"./carriers/40x40/8K.png": 367909,
	"./carriers/40x40/8L.png": 297482,
	"./carriers/40x40/8M.png": 29395,
	"./carriers/40x40/8N.png": 233784,
	"./carriers/40x40/8P.png": 288022,
	"./carriers/40x40/8Q.png": 701311,
	"./carriers/40x40/8R.png": 848100,
	"./carriers/40x40/8S.png": 101997,
	"./carriers/40x40/8T.png": 297138,
	"./carriers/40x40/8U.png": 11963,
	"./carriers/40x40/8V.png": 749984,
	"./carriers/40x40/8W.png": 628105,
	"./carriers/40x40/8Y.png": 351079,
	"./carriers/40x40/8Z.png": 932076,
	"./carriers/40x40/9A.png": 40472,
	"./carriers/40x40/9B.png": 731315,
	"./carriers/40x40/9C.png": 576106,
	"./carriers/40x40/9D.png": 560773,
	"./carriers/40x40/9E.png": 31356,
	"./carriers/40x40/9F.png": 831991,
	"./carriers/40x40/9H.png": 962009,
	"./carriers/40x40/9I.png": 881456,
	"./carriers/40x40/9J.png": 634955,
	"./carriers/40x40/9K.png": 413826,
	"./carriers/40x40/9L.png": 810173,
	"./carriers/40x40/9M.png": 589044,
	"./carriers/40x40/9N.png": 807951,
	"./carriers/40x40/9O.png": 285286,
	"./carriers/40x40/9P.png": 467249,
	"./carriers/40x40/9Q.png": 53032,
	"./carriers/40x40/9R.png": 338307,
	"./carriers/40x40/9S.png": 537082,
	"./carriers/40x40/9T.png": 293589,
	"./carriers/40x40/9U.png": 408140,
	"./carriers/40x40/9V.png": 844551,
	"./carriers/40x40/9X.png": 855145,
	"./carriers/40x40/9Y.png": 883968,
	"./carriers/40x40/A0.png": 494697,
	"./carriers/40x40/A1.png": 370496,
	"./carriers/40x40/A2.png": 268059,
	"./carriers/40x40/A3.png": 946514,
	"./carriers/40x40/A4.png": 276493,
	"./carriers/40x40/A5.png": 613252,
	"./carriers/40x40/A6.png": 898527,
	"./carriers/40x40/A7.png": 844726,
	"./carriers/40x40/A8.png": 683505,
	"./carriers/40x40/A9.png": 235112,
	"./carriers/40x40/AA.png": 835088,
	"./carriers/40x40/AB.png": 748907,
	"./carriers/40x40/AC.png": 374754,
	"./carriers/40x40/AD.png": 20125,
	"./carriers/40x40/AE.png": 798996,
	"./carriers/40x40/AF.png": 820463,
	"./carriers/40x40/AG.png": 238918,
	"./carriers/40x40/AH.png": 366785,
	"./carriers/40x40/AI.png": 629304,
	"./carriers/40x40/AJ.png": 941267,
	"./carriers/40x40/AK.png": 209354,
	"./carriers/40x40/AL.png": 279781,
	"./carriers/40x40/AM.png": 43868,
	"./carriers/40x40/AN.png": 751447,
	"./carriers/40x40/AO.png": 51950,
	"./carriers/40x40/AP.png": 539977,
	"./carriers/40x40/AQ.png": 145504,
	"./carriers/40x40/AR.png": 923835,
	"./carriers/40x40/AS.png": 209010,
	"./carriers/40x40/AT.png": 13869,
	"./carriers/40x40/AU.png": 759972,
	"./carriers/40x40/AV.png": 96831,
	"./carriers/40x40/AW.png": 199894,
	"./carriers/40x40/AX.png": 677201,
	"./carriers/40x40/AY.png": 166984,
	"./carriers/40x40/AZ.png": 503843,
	"./carriers/40x40/B0.png": 278484,
	"./carriers/40x40/B2.png": 930310,
	"./carriers/40x40/B3.png": 969327,
	"./carriers/40x40/B4.png": 857104,
	"./carriers/40x40/B5.png": 863353,
	"./carriers/40x40/B6.png": 7266,
	"./carriers/40x40/B7.png": 744747,
	"./carriers/40x40/B8.png": 218908,
	"./carriers/40x40/B9.png": 301797,
	"./carriers/40x40/BA.png": 32461,
	"./carriers/40x40/BB.png": 150838,
	"./carriers/40x40/BC.png": 747167,
	"./carriers/40x40/BD.png": 795840,
	"./carriers/40x40/BE.png": 250665,
	"./carriers/40x40/BF.png": 159954,
	"./carriers/40x40/BG.png": 574171,
	"./carriers/40x40/BH.png": 320012,
	"./carriers/40x40/BI.png": 689109,
	"./carriers/40x40/BJ.png": 521758,
	"./carriers/40x40/BK.png": 240071,
	"./carriers/40x40/BL.png": 964904,
	"./carriers/40x40/BM.png": 862769,
	"./carriers/40x40/BN.png": 932602,
	"./carriers/40x40/BO.png": 250179,
	"./carriers/40x40/BP.png": 500916,
	"./carriers/40x40/BQ.png": 722045,
	"./carriers/40x40/BR.png": 680806,
	"./carriers/40x40/BS.png": 719823,
	"./carriers/40x40/BT.png": 276976,
	"./carriers/40x40/BU.png": 873881,
	"./carriers/40x40/BV.png": 325698,
	"./carriers/40x40/BW.png": 546827,
	"./carriers/40x40/BX.png": 943228,
	"./carriers/40x40/BY.png": 472645,
	"./carriers/40x40/BZ.png": 84494,
	"./carriers/40x40/C0.png": 605439,
	"./carriers/40x40/C2.png": 734381,
	"./carriers/40x40/C3.png": 691876,
	"./carriers/40x40/C4.png": 101819,
	"./carriers/40x40/C5.png": 352818,
	"./carriers/40x40/C6.png": 717961,
	"./carriers/40x40/C7.png": 746784,
	"./carriers/40x40/C8.png": 890407,
	"./carriers/40x40/C9.png": 502718,
	"./carriers/40x40/CA.png": 133222,
	"./carriers/40x40/CC.png": 953332,
	"./carriers/40x40/CD.png": 999243,
	"./carriers/40x40/CE.png": 778114,
	"./carriers/40x40/CF.png": 326297,
	"./carriers/40x40/CG.png": 729392,
	"./carriers/40x40/CH.png": 196279,
	"./carriers/40x40/CI.png": 536910,
	"./carriers/40x40/CJ.png": 925061,
	"./carriers/40x40/CK.png": 395644,
	"./carriers/40x40/CL.png": 579251,
	"./carriers/40x40/CM.png": 940394,
	"./carriers/40x40/CN.png": 889377,
	"./carriers/40x40/CO.png": 404760,
	"./carriers/40x40/CP.png": 199583,
	"./carriers/40x40/CQ.png": 603254,
	"./carriers/40x40/CS.png": 244932,
	"./carriers/40x40/CT.png": 26587,
	"./carriers/40x40/CU.png": 612370,
	"./carriers/40x40/CV.png": 703081,
	"./carriers/40x40/CW.png": 248256,
	"./carriers/40x40/CX.png": 692487,
	"./carriers/40x40/CY.png": 974174,
	"./carriers/40x40/CZ.png": 141525,
	"./carriers/40x40/D0.png": 343154,
	"./carriers/40x40/D2.png": 737120,
	"./carriers/40x40/D3.png": 708297,
	"./carriers/40x40/D4.png": 817686,
	"./carriers/40x40/D5.png": 595775,
	"./carriers/40x40/D6.png": 682212,
	"./carriers/40x40/D7.png": 724717,
	"./carriers/40x40/D8.png": 720858,
	"./carriers/40x40/D9.png": 942435,
	"./carriers/40x40/DC.png": 316633,
	"./carriers/40x40/DD.png": 123558,
	"./carriers/40x40/DE.png": 162575,
	"./carriers/40x40/DF.png": 943668,
	"./carriers/40x40/DG.png": 164797,
	"./carriers/40x40/DH.png": 930730,
	"./carriers/40x40/DI.png": 569587,
	"./carriers/40x40/DJ.png": 395096,
	"./carriers/40x40/DK.png": 879713,
	"./carriers/40x40/DL.png": 527246,
	"./carriers/40x40/DM.png": 186615,
	"./carriers/40x40/DN.png": 385980,
	"./carriers/40x40/DO.png": 915397,
	"./carriers/40x40/DP.png": 602706,
	"./carriers/40x40/DQ.png": 16923,
	"./carriers/40x40/DR.png": 238592,
	"./carriers/40x40/DS.png": 693417,
	"./carriers/40x40/DT.png": 593590,
	"./carriers/40x40/DU.png": 189919,
	"./carriers/40x40/DV.png": 235268,
	"./carriers/40x40/DW.png": 475213,
	"./carriers/40x40/DX.png": 375354,
	"./carriers/40x40/DY.png": 692931,
	"./carriers/40x40/DZ.png": 407656,
	"./carriers/40x40/E2.png": 457743,
	"./carriers/40x40/E3.png": 418726,
	"./carriers/40x40/E4.png": 611801,
	"./carriers/40x40/E5.png": 14896,
	"./carriers/40x40/E6.png": 284747,
	"./carriers/40x40/E7.png": 63618,
	"./carriers/40x40/E8.png": 694213,
	"./carriers/40x40/E9.png": 681148,
	"./carriers/40x40/EB.png": 890943,
	"./carriers/40x40/EC.png": 112854,
	"./carriers/40x40/ED.png": 487113,
	"./carriers/40x40/EE.png": 32288,
	"./carriers/40x40/EF.png": 387323,
	"./carriers/40x40/EG.png": 121970,
	"./carriers/40x40/EH.png": 873973,
	"./carriers/40x40/EI.png": 791084,
	"./carriers/40x40/EJ.png": 175911,
	"./carriers/40x40/EK.png": 788222,
	"./carriers/40x40/EL.png": 624337,
	"./carriers/40x40/EM.png": 384392,
	"./carriers/40x40/EN.png": 721251,
	"./carriers/40x40/EO.png": 16026,
	"./carriers/40x40/EP.png": 449437,
	"./carriers/40x40/EQ.png": 16404,
	"./carriers/40x40/ER.png": 190895,
	"./carriers/40x40/ES.png": 151878,
	"./carriers/40x40/ET.png": 601273,
	"./carriers/40x40/EU.png": 595024,
	"./carriers/40x40/EV.png": 966315,
	"./carriers/40x40/EW.png": 745186,
	"./carriers/40x40/EX.png": 39717,
	"./carriers/40x40/EY.png": 956828,
	"./carriers/40x40/EZ.png": 214935,
	"./carriers/40x40/F0.png": 272056,
	"./carriers/40x40/F2.png": 852106,
	"./carriers/40x40/F3.png": 584019,
	"./carriers/40x40/F4.png": 686620,
	"./carriers/40x40/F5.png": 922533,
	"./carriers/40x40/F6.png": 694702,
	"./carriers/40x40/F7.png": 394199,
	"./carriers/40x40/F8.png": 477840,
	"./carriers/40x40/F9.png": 484089,
	"./carriers/40x40/FA.png": 326257,
	"./carriers/40x40/FB.png": 150010,
	"./carriers/40x40/FC.png": 739843,
	"./carriers/40x40/FD.png": 206796,
	"./carriers/40x40/FE.png": 118421,
	"./carriers/40x40/FF.png": 281694,
	"./carriers/40x40/FG.png": 457479,
	"./carriers/40x40/FH.png": 13248,
	"./carriers/40x40/FI.png": 137449,
	"./carriers/40x40/FJ.png": 589266,
	"./carriers/40x40/FK.png": 394459,
	"./carriers/40x40/FL.png": 739652,
	"./carriers/40x40/FM.png": 919245,
	"./carriers/40x40/FN.png": 487478,
	"./carriers/40x40/FO.png": 541279,
	"./carriers/40x40/FP.png": 865304,
	"./carriers/40x40/FQ.png": 654369,
	"./carriers/40x40/FR.png": 705386,
	"./carriers/40x40/FS.png": 556147,
	"./carriers/40x40/FT.png": 856188,
	"./carriers/40x40/FU.png": 173701,
	"./carriers/40x40/FV.png": 971278,
	"./carriers/40x40/FW.png": 444919,
	"./carriers/40x40/FX.png": 71088,
	"./carriers/40x40/FY.png": 303193,
	"./carriers/40x40/FZ.png": 272834,
	"./carriers/40x40/G0.png": 599011,
	"./carriers/40x40/G2.png": 772369,
	"./carriers/40x40/G3.png": 262152,
	"./carriers/40x40/G4.png": 841767,
	"./carriers/40x40/G5.png": 89278,
	"./carriers/40x40/G6.png": 175029,
	"./carriers/40x40/G7.png": 939116,
	"./carriers/40x40/G8.png": 19003,
	"./carriers/40x40/G9.png": 304178,
	"./carriers/40x40/GA.png": 157802,
	"./carriers/40x40/GB.png": 106785,
	"./carriers/40x40/GC.png": 834072,
	"./carriers/40x40/GD.png": 897335,
	"./carriers/40x40/GE.png": 423694,
	"./carriers/40x40/GF.png": 142469,
	"./carriers/40x40/GH.png": 488907,
	"./carriers/40x40/GI.png": 241602,
	"./carriers/40x40/GJ.png": 755609,
	"./carriers/40x40/GK.png": 523504,
	"./carriers/40x40/GL.png": 635727,
	"./carriers/40x40/GM.png": 350630,
	"./carriers/40x40/GO.png": 713268,
	"./carriers/40x40/GP.png": 192259,
	"./carriers/40x40/GQ.png": 602426,
	"./carriers/40x40/GR.png": 778673,
	"./carriers/40x40/GS.png": 330280,
	"./carriers/40x40/GT.png": 909895,
	"./carriers/40x40/GU.png": 734110,
	"./carriers/40x40/GV.png": 570837,
	"./carriers/40x40/GW.png": 659212,
	"./carriers/40x40/GX.png": 363227,
	"./carriers/40x40/GY.png": 41682,
	"./carriers/40x40/GZ.png": 589865,
	"./carriers/40x40/H1.png": 905967,
	"./carriers/40x40/H2.png": 884500,
	"./carriers/40x40/H3.png": 105629,
	"./carriers/40x40/H4.png": 460258,
	"./carriers/40x40/H5.png": 834411,
	"./carriers/40x40/H6.png": 920592,
	"./carriers/40x40/H7.png": 926841,
	"./carriers/40x40/H8.png": 137454,
	"./carriers/40x40/H9.png": 836951,
	"./carriers/40x40/HA.png": 984031,
	"./carriers/40x40/HB.png": 698756,
	"./carriers/40x40/HC.png": 361997,
	"./carriers/40x40/HD.png": 32018,
	"./carriers/40x40/HF.png": 456000,
	"./carriers/40x40/HH.png": 724446,
	"./carriers/40x40/HJ.png": 649548,
	"./carriers/40x40/HK.png": 561173,
	"./carriers/40x40/HM.png": 182595,
	"./carriers/40x40/HN.png": 320616,
	"./carriers/40x40/HO.png": 769009,
	"./carriers/40x40/HP.png": 340966,
	"./carriers/40x40/HQ.png": 626063,
	"./carriers/40x40/HR.png": 703604,
	"./carriers/40x40/HS.png": 924733,
	"./carriers/40x40/HT.png": 231938,
	"./carriers/40x40/HU.png": 479243,
	"./carriers/40x40/HV.png": 513840,
	"./carriers/40x40/HW.png": 745945,
	"./carriers/40x40/HX.png": 414030,
	"./carriers/40x40/HY.png": 887671,
	"./carriers/40x40/HZ.png": 298940,
	"./carriers/40x40/I2.png": 451315,
	"./carriers/40x40/I3.png": 600554,
	"./carriers/40x40/I4.png": 585221,
	"./carriers/40x40/I5.png": 751356,
	"./carriers/40x40/I6.png": 856439,
	"./carriers/40x40/I7.png": 866446,
	"./carriers/40x40/I8.png": 198361,
	"./carriers/40x40/I9.png": 966256,
	"./carriers/40x40/IA.png": 704904,
	"./carriers/40x40/IB.png": 41763,
	"./carriers/40x40/IC.png": 794010,
	"./carriers/40x40/ID.png": 617781,
	"./carriers/40x40/IE.png": 381868,
	"./carriers/40x40/IF.png": 284519,
	"./carriers/40x40/IG.png": 532030,
	"./carriers/40x40/IH.png": 77897,
	"./carriers/40x40/II.png": 683424,
	"./carriers/40x40/IJ.png": 461755,
	"./carriers/40x40/IK.png": 746930,
	"./carriers/40x40/IL.png": 551789,
	"./carriers/40x40/IM.png": 297892,
	"./carriers/40x40/IN.png": 634751,
	"./carriers/40x40/IO.png": 737814,
	"./carriers/40x40/IP.png": 904705,
	"./carriers/40x40/IQ.png": 167224,
	"./carriers/40x40/IR.png": 479187,
	"./carriers/40x40/IS.png": 747274,
	"./carriers/40x40/IT.png": 817701,
	"./carriers/40x40/IU.png": 581788,
	"./carriers/40x40/IV.png": 289367,
	"./carriers/40x40/IW.png": 589870,
	"./carriers/40x40/IX.png": 379257,
	"./carriers/40x40/IY.png": 373008,
	"./carriers/40x40/IZ.png": 286827,
	"./carriers/40x40/J0.png": 554380,
	"./carriers/40x40/J1.png": 466005,
	"./carriers/40x40/J2.png": 629278,
	"./carriers/40x40/J3.png": 805063,
	"./carriers/40x40/J4.png": 225448,
	"./carriers/40x40/J5.png": 673841,
	"./carriers/40x40/J6.png": 497594,
	"./carriers/40x40/J7.png": 603779,
	"./carriers/40x40/J8.png": 603588,
	"./carriers/40x40/J9.png": 266829,
	"./carriers/40x40/JA.png": 270117,
	"./carriers/40x40/JB.png": 42286,
	"./carriers/40x40/JC.png": 741783,
	"./carriers/40x40/JD.png": 619640,
	"./carriers/40x40/JE.png": 357121,
	"./carriers/40x40/JF.png": 199690,
	"./carriers/40x40/JG.png": 931603,
	"./carriers/40x40/JH.png": 789332,
	"./carriers/40x40/JI.png": 10461,
	"./carriers/40x40/JJ.png": 229254,
	"./carriers/40x40/JK.png": 810799,
	"./carriers/40x40/JL.png": 825424,
	"./carriers/40x40/JM.png": 831673,
	"./carriers/40x40/JO.png": 739243,
	"./carriers/40x40/JP.png": 834284,
	"./carriers/40x40/JQ.png": 70197,
	"./carriers/40x40/JR.png": 984446,
	"./carriers/40x40/JS.png": 736935,
	"./carriers/40x40/JT.png": 157320,
	"./carriers/40x40/JU.png": 667537,
	"./carriers/40x40/JV.png": 246426,
	"./carriers/40x40/JX.png": 750308,
	"./carriers/40x40/JY.png": 4205,
	"./carriers/40x40/JZ.png": 190230,
	"./carriers/40x40/K1.png": 38126,
	"./carriers/40x40/K2.png": 292133,
	"./carriers/40x40/K3.png": 209244,
	"./carriers/40x40/K4.png": 80467,
	"./carriers/40x40/K6.png": 955841,
	"./carriers/40x40/K7.png": 218360,
	"./carriers/40x40/K8.png": 959663,
	"./carriers/40x40/K9.png": 920646,
	"./carriers/40x40/KA.png": 512094,
	"./carriers/40x40/KB.png": 679445,
	"./carriers/40x40/KC.png": 310348,
	"./carriers/40x40/KD.png": 240515,
	"./carriers/40x40/KE.png": 922938,
	"./carriers/40x40/KF.png": 853105,
	"./carriers/40x40/KG.png": 955240,
	"./carriers/40x40/KH.png": 737503,
	"./carriers/40x40/KI.png": 141174,
	"./carriers/40x40/KJ.png": 22797,
	"./carriers/40x40/KK.png": 782852,
	"./carriers/40x40/KL.png": 564507,
	"./carriers/40x40/KM.png": 150290,
	"./carriers/40x40/KN.png": 241001,
	"./carriers/40x40/KO.png": 786176,
	"./carriers/40x40/KP.png": 734199,
	"./carriers/40x40/KQ.png": 74830,
	"./carriers/40x40/KR.png": 462981,
	"./carriers/40x40/KS.png": 933564,
	"./carriers/40x40/KT.png": 117171,
	"./carriers/40x40/KU.png": 478314,
	"./carriers/40x40/KV.png": 427297,
	"./carriers/40x40/KW.png": 942680,
	"./carriers/40x40/KX.png": 710159,
	"./carriers/40x40/KY.png": 671142,
	"./carriers/40x40/KZ.png": 712381,
	"./carriers/40x40/L2.png": 208696,
	"./carriers/40x40/L3.png": 946177,
	"./carriers/40x40/L5.png": 457687,
	"./carriers/40x40/L6.png": 199580,
	"./carriers/40x40/L7.png": 282469,
	"./carriers/40x40/L8.png": 987938,
	"./carriers/40x40/L9.png": 725419,
	"./carriers/40x40/LA.png": 230851,
	"./carriers/40x40/LB.png": 945576,
	"./carriers/40x40/LC.png": 843441,
	"./carriers/40x40/LD.png": 502430,
	"./carriers/40x40/LE.png": 220743,
	"./carriers/40x40/LF.png": 300684,
	"./carriers/40x40/LG.png": 669781,
	"./carriers/40x40/LH.png": 140626,
	"./carriers/40x40/LI.png": 554843,
	"./carriers/40x40/LJ.png": 776512,
	"./carriers/40x40/LK.png": 231337,
	"./carriers/40x40/LL.png": 131510,
	"./carriers/40x40/LM.png": 727839,
	"./carriers/40x40/LN.png": 773188,
	"./carriers/40x40/LO.png": 13133,
	"./carriers/40x40/LP.png": 468650,
	"./carriers/40x40/LQ.png": 107507,
	"./carriers/40x40/LR.png": 933016,
	"./carriers/40x40/LS.png": 417633,
	"./carriers/40x40/LT.png": 65166,
	"./carriers/40x40/LU.png": 724535,
	"./carriers/40x40/LV.png": 923900,
	"./carriers/40x40/LW.png": 453317,
	"./carriers/40x40/LX.png": 306370,
	"./carriers/40x40/LY.png": 527499,
	"./carriers/40x40/LZ.png": 257648,
	"./carriers/40x40/M0.png": 85493,
	"./carriers/40x40/M2.png": 871079,
	"./carriers/40x40/M3.png": 483390,
	"./carriers/40x40/M4.png": 835857,
	"./carriers/40x40/M5.png": 79560,
	"./carriers/40x40/M6.png": 932771,
	"./carriers/40x40/M7.png": 711194,
	"./carriers/40x40/M8.png": 715053,
	"./carriers/40x40/M9.png": 672548,
	"./carriers/40x40/MB.png": 176951,
	"./carriers/40x40/MD.png": 870049,
	"./carriers/40x40/ME.png": 385432,
	"./carriers/40x40/MF.png": 559923,
	"./carriers/40x40/MG.png": 921066,
	"./carriers/40x40/MH.png": 155133,
	"./carriers/40x40/MI.png": 934004,
	"./carriers/40x40/MJ.png": 152911,
	"./carriers/40x40/MK.png": 113894,
	"./carriers/40x40/ML.png": 306969,
	"./carriers/40x40/MM.png": 710064,
	"./carriers/40x40/MN.png": 979915,
	"./carriers/40x40/MO.png": 758786,
	"./carriers/40x40/MP.png": 122197,
	"./carriers/40x40/MQ.png": 753100,
	"./carriers/40x40/MR.png": 673159,
	"./carriers/40x40/MS.png": 954846,
	"./carriers/40x40/MT.png": 295857,
	"./carriers/40x40/MU.png": 397992,
	"./carriers/40x40/MV.png": 683267,
	"./carriers/40x40/MW.png": 365690,
	"./carriers/40x40/MX.png": 465549,
	"./carriers/40x40/MY.png": 225604,
	"./carriers/40x40/MZ.png": 180255,
	"./carriers/40x40/N0.png": 5232,
	"./carriers/40x40/N2.png": 53954,
	"./carriers/40x40/N3.png": 275083,
	"./carriers/40x40/N4.png": 229172,
	"./carriers/40x40/N5.png": 450301,
	"./carriers/40x40/N7.png": 448079,
	"./carriers/40x40/N8.png": 680600,
	"./carriers/40x40/N9.png": 648865,
	"./carriers/40x40/NA.png": 477449,
	"./carriers/40x40/NB.png": 112306,
	"./carriers/40x40/NC.png": 377659,
	"./carriers/40x40/ND.png": 967716,
	"./carriers/40x40/NE.png": 493869,
	"./carriers/40x40/NF.png": 103190,
	"./carriers/40x40/NG.png": 881279,
	"./carriers/40x40/NH.png": 374728,
	"./carriers/40x40/NI.png": 614673,
	"./carriers/40x40/NJ.png": 6362,
	"./carriers/40x40/NK.png": 711587,
	"./carriers/40x40/NL.png": 781420,
	"./carriers/40x40/NM.png": 864309,
	"./carriers/40x40/NN.png": 778558,
	"./carriers/40x40/NO.png": 166247,
	"./carriers/40x40/NP.png": 585360,
	"./carriers/40x40/NQ.png": 591609,
	"./carriers/40x40/NR.png": 735522,
	"./carriers/40x40/NS.png": 956651,
	"./carriers/40x40/NT.png": 6740,
	"./carriers/40x40/NU.png": 439773,
	"./carriers/40x40/NV.png": 142214,
	"./carriers/40x40/NX.png": 956280,
	"./carriers/40x40/NY.png": 177409,
	"./carriers/40x40/NZ.png": 663178,
	"./carriers/40x40/O3.png": 976512,
	"./carriers/40x40/O4.png": 927839,
	"./carriers/40x40/O7.png": 973188,
	"./carriers/40x40/O9.png": 113274,
	"./carriers/40x40/OA.png": 187938,
	"./carriers/40x40/OB.png": 44025,
	"./carriers/40x40/OC.png": 37776,
	"./carriers/40x40/OD.png": 633647,
	"./carriers/40x40/OE.png": 110982,
	"./carriers/40x40/OF.png": 892189,
	"./carriers/40x40/OG.png": 459156,
	"./carriers/40x40/OH.png": 754451,
	"./carriers/40x40/OI.png": 115594,
	"./carriers/40x40/OJ.png": 629825,
	"./carriers/40x40/OK.png": 408696,
	"./carriers/40x40/OL.png": 657687,
	"./carriers/40x40/OM.png": 712110,
	"./carriers/40x40/ON.png": 482469,
	"./carriers/40x40/OO.png": 399580,
	"./carriers/40x40/OP.png": 830075,
	"./carriers/40x40/OQ.png": 564722,
	"./carriers/40x40/OR.png": 929865,
	"./carriers/40x40/OS.png": 475040,
	"./carriers/40x40/OT.png": 333695,
	"./carriers/40x40/OU.png": 555606,
	"./carriers/40x40/OV.png": 946285,
	"./carriers/40x40/OW.png": 420132,
	"./carriers/40x40/OY.png": 458778,
	"./carriers/40x40/OZ.png": 67089,
	"./carriers/40x40/P0.png": 692766,
	"./carriers/40x40/P1.png": 411079,
	"./carriers/40x40/P2.png": 491020,
	"./carriers/40x40/P3.png": 860117,
	"./carriers/40x40/P4.png": 103610,
	"./carriers/40x40/P5.png": 421187,
	"./carriers/40x40/P6.png": 135912,
	"./carriers/40x40/P7.png": 33777,
	"./carriers/40x40/P8.png": 321846,
	"./carriers/40x40/P9.png": 918175,
	"./carriers/40x40/PA.png": 648023,
	"./carriers/40x40/PB.png": 389916,
	"./carriers/40x40/PC.png": 472805,
	"./carriers/40x40/PD.png": 105930,
	"./carriers/40x40/PE.png": 744787,
	"./carriers/40x40/PF.png": 399032,
	"./carriers/40x40/PG.png": 620161,
	"./carriers/40x40/PH.png": 101318,
	"./carriers/40x40/PI.png": 623983,
	"./carriers/40x40/PJ.png": 449492,
	"./carriers/40x40/PK.png": 882525,
	"./carriers/40x40/PL.png": 178274,
	"./carriers/40x40/PM.png": 399403,
	"./carriers/40x40/PN.png": 28112,
	"./carriers/40x40/PO.png": 34361,
	"./carriers/40x40/PQ.png": 608999,
	"./carriers/40x40/PR.png": 224172,
	"./carriers/40x40/PS.png": 307061,
	"./carriers/40x40/PT.png": 449114,
	"./carriers/40x40/PU.png": 154339,
	"./carriers/40x40/PV.png": 817480,
	"./carriers/40x40/PW.png": 57425,
	"./carriers/40x40/PX.png": 545942,
	"./carriers/40x40/PY.png": 324031,
	"./carriers/40x40/PZ.png": 410468,
	"./carriers/40x40/Q2.png": 824747,
	"./carriers/40x40/Q3.png": 450594,
	"./carriers/40x40/Q4.png": 95965,
	"./carriers/40x40/Q5.png": 874836,
	"./carriers/40x40/Q6.png": 896303,
	"./carriers/40x40/Q7.png": 314758,
	"./carriers/40x40/Q8.png": 442625,
	"./carriers/40x40/Q9.png": 705144,
	"./carriers/40x40/QA.png": 446336,
	"./carriers/40x40/QB.png": 343899,
	"./carriers/40x40/QC.png": 22354,
	"./carriers/40x40/QD.png": 352333,
	"./carriers/40x40/QE.png": 689092,
	"./carriers/40x40/QF.png": 974367,
	"./carriers/40x40/QG.png": 920566,
	"./carriers/40x40/QH.png": 759345,
	"./carriers/40x40/QI.png": 310952,
	"./carriers/40x40/QK.png": 583098,
	"./carriers/40x40/QL.png": 551509,
	"./carriers/40x40/QM.png": 639884,
	"./carriers/40x40/QN.png": 890567,
	"./carriers/40x40/QO.png": 714782,
	"./carriers/40x40/QP.png": 736281,
	"./carriers/40x40/QQ.png": 504176,
	"./carriers/40x40/QR.png": 469579,
	"./carriers/40x40/QS.png": 222274,
	"./carriers/40x40/QT.png": 915069,
	"./carriers/40x40/QU.png": 693940,
	"./carriers/40x40/QV.png": 616399,
	"./carriers/40x40/QW.png": 331302,
	"./carriers/40x40/QX.png": 87457,
	"./carriers/40x40/QY.png": 814744,
	"./carriers/40x40/QZ.png": 989235,
	"./carriers/40x40/R0.png": 288228,
	"./carriers/40x40/R2.png": 728150,
	"./carriers/40x40/R3.png": 625087,
	"./carriers/40x40/R4.png": 673760,
	"./carriers/40x40/R5.png": 68233,
	"./carriers/40x40/R6.png": 737266,
	"./carriers/40x40/R7.png": 452091,
	"./carriers/40x40/R9.png": 608117,
	"./carriers/40x40/RA.png": 367485,
	"./carriers/40x40/RB.png": 783718,
	"./carriers/40x40/RC.png": 68815,
	"./carriers/40x40/RD.png": 956592,
	"./carriers/40x40/RE.png": 188697,
	"./carriers/40x40/RF.png": 674690,
	"./carriers/40x40/RG.png": 921995,
	"./carriers/40x40/RH.png": 741692,
	"./carriers/40x40/RI.png": 575557,
	"./carriers/40x40/RJ.png": 856782,
	"./carriers/40x40/RK.png": 846775,
	"./carriers/40x40/RL.png": 267160,
	"./carriers/40x40/RM.png": 539873,
	"./carriers/40x40/RN.png": 590890,
	"./carriers/40x40/RO.png": 441651,
	"./carriers/40x40/RP.png": 141508,
	"./carriers/40x40/RQ.png": 804749,
	"./carriers/40x40/RR.png": 372982,
	"./carriers/40x40/RS.png": 426783,
	"./carriers/40x40/RT.png": 898752,
	"./carriers/40x40/RU.png": 22953,
	"./carriers/40x40/RV.png": 474770,
	"./carriers/40x40/RW.png": 796315,
	"./carriers/40x40/RX.png": 92300,
	"./carriers/40x40/RY.png": 3925,
	"./carriers/40x40/RZ.png": 167198,
	"./carriers/40x40/S0.png": 521231,
	"./carriers/40x40/S1.png": 236134,
	"./carriers/40x40/S2.png": 819901,
	"./carriers/40x40/S4.png": 890763,
	"./carriers/40x40/S5.png": 127106,
	"./carriers/40x40/S6.png": 641113,
	"./carriers/40x40/S7.png": 409008,
	"./carriers/40x40/S8.png": 299191,
	"./carriers/40x40/S9.png": 309198,
	"./carriers/40x40/SA.png": 180566,
	"./carriers/40x40/SB.png": 994541,
	"./carriers/40x40/SC.png": 740644,
	"./carriers/40x40/SD.png": 904507,
	"./carriers/40x40/SE.png": 189682,
	"./carriers/40x40/SF.png": 520649,
	"./carriers/40x40/SG.png": 126176,
	"./carriers/40x40/SH.png": 727271,
	"./carriers/40x40/SI.png": 974782,
	"./carriers/40x40/SJ.png": 60533,
	"./carriers/40x40/SK.png": 824620,
	"./carriers/40x40/SL.png": 484515,
	"./carriers/40x40/SM.png": 236762,
	"./carriers/40x40/SN.png": 657873,
	"./carriers/40x40/SO.png": 147656,
	"./carriers/40x40/SP.png": 801135,
	"./carriers/40x40/SQ.png": 219590,
	"./carriers/40x40/SR.png": 797,
	"./carriers/40x40/SS.png": 779668,
	"./carriers/40x40/ST.png": 729579,
	"./carriers/40x40/SU.png": 355426,
	"./carriers/40x40/SV.png": 822009,
	"./carriers/40x40/SW.png": 815760,
	"./carriers/40x40/SX.png": 732119,
	"./carriers/40x40/SY.png": 32622,
	"./carriers/40x40/SZ.png": 260453,
	"./carriers/40x40/T0.png": 117442,
	"./carriers/40x40/T2.png": 399344,
	"./carriers/40x40/T3.png": 631449,
	"./carriers/40x40/T4.png": 226470,
	"./carriers/40x40/T5.png": 511567,
	"./carriers/40x40/T6.png": 589108,
	"./carriers/40x40/T7.png": 810237,
	"./carriers/40x40/T9.png": 884403,
	"./carriers/40x40/TA.png": 894843,
	"./carriers/40x40/TB.png": 116512,
	"./carriers/40x40/TC.png": 510985,
	"./carriers/40x40/TD.png": 170902,
	"./carriers/40x40/TE.png": 67839,
	"./carriers/40x40/TF.png": 730980,
	"./carriers/40x40/TG.png": 984877,
	"./carriers/40x40/TH.png": 227098,
	"./carriers/40x40/TI.png": 474851,
	"./carriers/40x40/TJ.png": 137992,
	"./carriers/40x40/TK.png": 648209,
	"./carriers/40x40/TL.png": 965118,
	"./carriers/40x40/TM.png": 717607,
	"./carriers/40x40/TN.png": 814956,
	"./carriers/40x40/TO.png": 50869,
	"./carriers/40x40/TP.png": 345762,
	"./carriers/40x40/TQ.png": 719915,
	"./carriers/40x40/TR.png": 583715,
	"./carriers/40x40/TS.png": 812345,
	"./carriers/40x40/TT.png": 209926,
	"./carriers/40x40/TU.png": 791471,
	"./carriers/40x40/TV.png": 770004,
	"./carriers/40x40/TW.png": 991133,
	"./carriers/40x40/TX.png": 180362,
	"./carriers/40x40/TY.png": 912275,
	"./carriers/40x40/TZ.png": 116664,
	"./carriers/40x40/U0.png": 699917,
	"./carriers/40x40/U2.png": 321951,
	"./carriers/40x40/U3.png": 268150,
	"./carriers/40x40/U4.png": 918121,
	"./carriers/40x40/U5.png": 793920,
	"./carriers/40x40/U6.png": 691483,
	"./carriers/40x40/U7.png": 369938,
	"./carriers/40x40/U8.png": 899093,
	"./carriers/40x40/UA.png": 222420,
	"./carriers/40x40/UB.png": 243887,
	"./carriers/40x40/UC.png": 662342,
	"./carriers/40x40/UD.png": 264761,
	"./carriers/40x40/UE.png": 258512,
	"./carriers/40x40/UF.png": 172331,
	"./carriers/40x40/UG.png": 798178,
	"./carriers/40x40/UH.png": 703205,
	"./carriers/40x40/UI.png": 467292,
	"./carriers/40x40/UJ.png": 174871,
	"./carriers/40x40/UK.png": 475374,
	"./carriers/40x40/UL.png": 790209,
	"./carriers/40x40/UM.png": 569080,
	"./carriers/40x40/UN.png": 364691,
	"./carriers/40x40/UO.png": 632778,
	"./carriers/40x40/UP.png": 437293,
	"./carriers/40x40/UQ.png": 183396,
	"./carriers/40x40/UR.png": 520255,
	"./carriers/40x40/US.png": 623318,
	"./carriers/40x40/UT.png": 963401,
	"./carriers/40x40/UU.png": 568928,
	"./carriers/40x40/UX.png": 503285,
	"./carriers/40x40/UY.png": 267372,
	"./carriers/40x40/UZ.png": 170023,
	"./carriers/40x40/V0.png": 69896,
	"./carriers/40x40/V2.png": 701530,
	"./carriers/40x40/V3.png": 923107,
	"./carriers/40x40/V4.png": 992940,
	"./carriers/40x40/V5.png": 75829,
	"./carriers/40x40/V6.png": 473726,
	"./carriers/40x40/V7.png": 861415,
	"./carriers/40x40/V8.png": 717792,
	"./carriers/40x40/V9.png": 688969,
	"./carriers/40x40/VA.png": 860385,
	"./carriers/40x40/VB.png": 911402,
	"./carriers/40x40/VC.png": 550259,
	"./carriers/40x40/VD.png": 366652,
	"./carriers/40x40/VE.png": 896069,
	"./carriers/40x40/VF.png": 507918,
	"./carriers/40x40/VH.png": 700400,
	"./carriers/40x40/VI.png": 297305,
	"./carriers/40x40/VJ.png": 749122,
	"./carriers/40x40/VK.png": 970251,
	"./carriers/40x40/VL.png": 924340,
	"./carriers/40x40/VM.png": 145469,
	"./carriers/40x40/VN.png": 104230,
	"./carriers/40x40/VO.png": 143247,
	"./carriers/40x40/VP.png": 388328,
	"./carriers/40x40/VQ.png": 286193,
	"./carriers/40x40/VR.png": 356026,
	"./carriers/40x40/VS.png": 673603,
	"./carriers/40x40/VT.png": 743436,
	"./carriers/40x40/VU.png": 112533,
	"./carriers/40x40/VV.png": 945182,
	"./carriers/40x40/VW.png": 663495,
	"./carriers/40x40/VY.png": 674089,
	"./carriers/40x40/VZ.png": 583378,
	"./carriers/40x40/W2.png": 639201,
	"./carriers/40x40/W3.png": 670936,
	"./carriers/40x40/W4.png": 946103,
	"./carriers/40x40/W5.png": 803086,
	"./carriers/40x40/W6.png": 674885,
	"./carriers/40x40/W7.png": 661820,
	"./carriers/40x40/W8.png": 265419,
	"./carriers/40x40/W9.png": 44290,
	"./carriers/40x40/WA.png": 996698,
	"./carriers/40x40/WB.png": 605009,
	"./carriers/40x40/WC.png": 365064,
	"./carriers/40x40/WD.png": 156583,
	"./carriers/40x40/WE.png": 768894,
	"./carriers/40x40/WF.png": 854645,
	"./carriers/40x40/WG.png": 771756,
	"./carriers/40x40/WH.png": 367995,
	"./carriers/40x40/WI.png": 102642,
	"./carriers/40x40/WJ.png": 467785,
	"./carriers/40x40/WK.png": 12960,
	"./carriers/40x40/WL.png": 871615,
	"./carriers/40x40/WM.png": 93526,
	"./carriers/40x40/WN.png": 484205,
	"./carriers/40x40/WO.png": 958052,
	"./carriers/40x40/WP.png": 292371,
	"./carriers/40x40/WQ.png": 653514,
	"./carriers/40x40/WR.png": 167745,
	"./carriers/40x40/WS.png": 946616,
	"./carriers/40x40/WT.png": 195607,
	"./carriers/40x40/WU.png": 250030,
	"./carriers/40x40/WV.png": 20389,
	"./carriers/40x40/WW.png": 937500,
	"./carriers/40x40/WX.png": 946987,
	"./carriers/40x40/WY.png": 725858,
	"./carriers/40x40/WZ.png": 581945,
	"./carriers/40x40/X3.png": 148141,
	"./carriers/40x40/X4.png": 766578,
	"./carriers/40x40/X5.png": 515579,
	"./carriers/40x40/X6.png": 160544,
	"./carriers/40x40/X7.png": 131721,
	"./carriers/40x40/X8.png": 916478,
	"./carriers/40x40/X9.png": 304167,
	"./carriers/40x40/XC.png": 588221,
	"./carriers/40x40/XE.png": 413003,
	"./carriers/40x40/XF.png": 143152,
	"./carriers/40x40/XG.png": 740057,
	"./carriers/40x40/XJ.png": 809404,
	"./carriers/40x40/XK.png": 338821,
	"./carriers/40x40/XL.png": 354154,
	"./carriers/40x40/XM.png": 993011,
	"./carriers/40x40/XN.png": 818520,
	"./carriers/40x40/XO.png": 303137,
	"./carriers/40x40/XP.png": 17014,
	"./carriers/40x40/XQ.png": 613343,
	"./carriers/40x40/XR.png": 658692,
	"./carriers/40x40/XT.png": 26130,
	"./carriers/40x40/XU.png": 440347,
	"./carriers/40x40/XW.png": 116841,
	"./carriers/40x40/XY.png": 106247,
	"./carriers/40x40/XZ.png": 186188,
	"./carriers/40x40/Y2.png": 411523,
	"./carriers/40x40/Y3.png": 93946,
	"./carriers/40x40/Y4.png": 850453,
	"./carriers/40x40/Y5.png": 481356,
	"./carriers/40x40/Y6.png": 401415,
	"./carriers/40x40/Y7.png": 683102,
	"./carriers/40x40/Y8.png": 412009,
	"./carriers/40x40/Y9.png": 957184,
	"./carriers/40x40/YB.png": 735123,
	"./carriers/40x40/YC.png": 96266,
	"./carriers/40x40/YD.png": 463141,
	"./carriers/40x40/YE.png": 380252,
	"./carriers/40x40/YG.png": 692782,
	"./carriers/40x40/YH.png": 24697,
	"./carriers/40x40/YI.png": 18448,
	"./carriers/40x40/YJ.png": 389739,
	"./carriers/40x40/YK.png": 168610,
	"./carriers/40x40/YL.png": 872861,
	"./carriers/40x40/YM.png": 439828,
	"./carriers/40x40/YN.png": 614319,
	"./carriers/40x40/YO.png": 91654,
	"./carriers/40x40/YP.png": 47761,
	"./carriers/40x40/YQ.png": 807816,
	"./carriers/40x40/YR.png": 144675,
	"./carriers/40x40/YS.png": 439450,
	"./carriers/40x40/YT.png": 297397,
	"./carriers/40x40/YU.png": 214508,
	"./carriers/40x40/YV.png": 599335,
	"./carriers/40x40/YW.png": 211646,
	"./carriers/40x40/YX.png": 910537,
	"./carriers/40x40/Z0.png": 110044,
	"./carriers/40x40/Z2.png": 118126,
	"./carriers/40x40/Z5.png": 432961,
	"./carriers/40x40/Z7.png": 7443,
	"./carriers/40x40/Z8.png": 865172,
	"./carriers/40x40/Z9.png": 86301,
	"./carriers/40x40/ZA.png": 541845,
	"./carriers/40x40/ZB.png": 705118,
	"./carriers/40x40/ZD.png": 301288,
	"./carriers/40x40/ZE.png": 749681,
	"./carriers/40x40/ZF.png": 573434,
	"./carriers/40x40/ZG.png": 163267,
	"./carriers/40x40/ZH.png": 679428,
	"./carriers/40x40/ZJ.png": 910902,
	"./carriers/40x40/ZK.png": 964703,
	"./carriers/40x40/ZL.png": 436672,
	"./carriers/40x40/ZM.png": 560873,
	"./carriers/40x40/ZN.png": 12690,
	"./carriers/40x40/ZO.png": 334235,
	"./carriers/40x40/ZP.png": 279612,
	"./carriers/40x40/ZQ.png": 113477,
	"./carriers/40x40/ZR.png": 394702,
	"./carriers/40x40/ZT.png": 805080,
	"./carriers/40x40/ZU.png": 77793,
	"./carriers/40x40/ZV.png": 128810,
	"./carriers/40x40/ZW.png": 979571,
	"./carriers/40x40/ZX.png": 684276,
	"./carriers/40x40/ZY.png": 905405,
	"./carriers/40x40/fallback.png": 161396,
	"./carriers/80x80/0B.png": 497340,
	"./carriers/80x80/0J.png": 385652,
	"./carriers/80x80/0N.png": 712240,
	"./carriers/80x80/0T.png": 791162,
	"./carriers/80x80/0V.png": 519016,
	"./carriers/80x80/1I.png": 903304,
	"./carriers/80x80/1X.png": 586753,
	"./carriers/80x80/2A.png": 208861,
	"./carriers/80x80/2B.png": 427654,
	"./carriers/80x80/2C.png": 492847,
	"./carriers/80x80/2D.png": 23824,
	"./carriers/80x80/2F.png": 47138,
	"./carriers/80x80/2G.png": 937643,
	"./carriers/80x80/2H.png": 716252,
	"./carriers/80x80/2I.png": 468517,
	"./carriers/80x80/2J.png": 240686,
	"./carriers/80x80/2K.png": 940183,
	"./carriers/80x80/2L.png": 818040,
	"./carriers/80x80/2M.png": 39169,
	"./carriers/80x80/2N.png": 398090,
	"./carriers/80x80/2O.png": 613651,
	"./carriers/80x80/2P.png": 948708,
	"./carriers/80x80/2Q.png": 202605,
	"./carriers/80x80/2R.png": 872278,
	"./carriers/80x80/2S.png": 285567,
	"./carriers/80x80/2T.png": 334240,
	"./carriers/80x80/2U.png": 212361,
	"./carriers/80x80/2V.png": 397746,
	"./carriers/80x80/2W.png": 112571,
	"./carriers/80x80/2Y.png": 268597,
	"./carriers/80x80/2Z.png": 182846,
	"./carriers/80x80/3A.png": 339574,
	"./carriers/80x80/3B.png": 221197,
	"./carriers/80x80/3C.png": 981252,
	"./carriers/80x80/3D.png": 246555,
	"./carriers/80x80/3E.png": 348690,
	"./carriers/80x80/3F.png": 439401,
	"./carriers/80x80/3G.png": 984576,
	"./carriers/80x80/3H.png": 428807,
	"./carriers/80x80/3J.png": 877845,
	"./carriers/80x80/3K.png": 508748,
	"./carriers/80x80/3L.png": 438915,
	"./carriers/80x80/3M.png": 121338,
	"./carriers/80x80/3N.png": 51505,
	"./carriers/80x80/3O.png": 637288,
	"./carriers/80x80/3P.png": 908559,
	"./carriers/80x80/3Q.png": 869542,
	"./carriers/80x80/3R.png": 910781,
	"./carriers/80x80/3S.png": 173300,
	"./carriers/80x80/3T.png": 735563,
	"./carriers/80x80/3U.png": 998082,
	"./carriers/80x80/3V.png": 62617,
	"./carriers/80x80/3W.png": 465712,
	"./carriers/80x80/3X.png": 416247,
	"./carriers/80x80/3Z.png": 145029,
	"./carriers/80x80/4A.png": 236891,
	"./carriers/80x80/4B.png": 974912,
	"./carriers/80x80/4C.png": 429737,
	"./carriers/80x80/4D.png": 329910,
	"./carriers/80x80/4E.png": 409887,
	"./carriers/80x80/4F.png": 971588,
	"./carriers/80x80/4G.png": 211533,
	"./carriers/80x80/4H.png": 111674,
	"./carriers/80x80/4I.png": 429251,
	"./carriers/80x80/4J.png": 627624,
	"./carriers/80x80/4K.png": 41841,
	"./carriers/80x80/4L.png": 700830,
	"./carriers/80x80/4M.png": 419143,
	"./carriers/80x80/4N.png": 499084,
	"./carriers/80x80/4O.png": 868181,
	"./carriers/80x80/4R.png": 456048,
	"./carriers/80x80/4S.png": 52953,
	"./carriers/80x80/4T.png": 859878,
	"./carriers/80x80/4U.png": 898895,
	"./carriers/80x80/4V.png": 163636,
	"./carriers/80x80/4W.png": 901117,
	"./carriers/80x80/4X.png": 150698,
	"./carriers/80x80/4Y.png": 305907,
	"./carriers/80x80/4Z.png": 131416,
	"./carriers/80x80/5A.png": 132404,
	"./carriers/80x80/5B.png": 351311,
	"./carriers/80x80/5C.png": 312294,
	"./carriers/80x80/5D.png": 505369,
	"./carriers/80x80/5E.png": 908464,
	"./carriers/80x80/5F.png": 178315,
	"./carriers/80x80/5G.png": 957186,
	"./carriers/80x80/5H.png": 587781,
	"./carriers/80x80/5I.png": 574716,
	"./carriers/80x80/5J.png": 858999,
	"./carriers/80x80/5K.png": 715982,
	"./carriers/80x80/5L.png": 552097,
	"./carriers/80x80/5M.png": 583832,
	"./carriers/80x80/5N.png": 758323,
	"./carriers/80x80/5O.png": 603114,
	"./carriers/80x80/5P.png": 663949,
	"./carriers/80x80/5Q.png": 424004,
	"./carriers/80x80/5R.png": 862303,
	"./carriers/80x80/5S.png": 782326,
	"./carriers/80x80/5T.png": 882153,
	"./carriers/80x80/5U.png": 427328,
	"./carriers/80x80/5V.png": 689307,
	"./carriers/80x80/5W.png": 791442,
	"./carriers/80x80/5X.png": 320597,
	"./carriers/80x80/5Y.png": 951500,
	"./carriers/80x80/5Z.png": 871559,
	"./carriers/80x80/6A.png": 375809,
	"./carriers/80x80/6B.png": 345226,
	"./carriers/80x80/6C.png": 500435,
	"./carriers/80x80/6D.png": 145564,
	"./carriers/80x80/6E.png": 712101,
	"./carriers/80x80/6F.png": 458094,
	"./carriers/80x80/6G.png": 887319,
	"./carriers/80x80/6H.png": 783760,
	"./carriers/80x80/6I.png": 790009,
	"./carriers/80x80/6J.png": 933922,
	"./carriers/80x80/6K.png": 155051,
	"./carriers/80x80/6L.png": 205140,
	"./carriers/80x80/6M.png": 121821,
	"./carriers/80x80/6N.png": 340614,
	"./carriers/80x80/6O.png": 379631,
	"./carriers/80x80/6P.png": 573128,
	"./carriers/80x80/6Q.png": 813073,
	"./carriers/80x80/6R.png": 688410,
	"./carriers/80x80/6S.png": 909987,
	"./carriers/80x80/6V.png": 976958,
	"./carriers/80x80/6W.png": 848295,
	"./carriers/80x80/6Y.png": 675849,
	"./carriers/80x80/6Z.png": 310706,
	"./carriers/80x80/7A.png": 338746,
	"./carriers/80x80/7B.png": 998641,
	"./carriers/80x80/7C.png": 66600,
	"./carriers/80x80/7D.png": 646215,
	"./carriers/80x80/7E.png": 470430,
	"./carriers/80x80/7F.png": 790805,
	"./carriers/80x80/7G.png": 879180,
	"./carriers/80x80/7H.png": 583195,
	"./carriers/80x80/7I.png": 261650,
	"./carriers/80x80/7J.png": 809833,
	"./carriers/80x80/7K.png": 685632,
	"./carriers/80x80/7L.png": 213663,
	"./carriers/80x80/7M.png": 159862,
	"./carriers/80x80/7O.png": 928388,
	"./carriers/80x80/7P.png": 228531,
	"./carriers/80x80/7Q.png": 377770,
	"./carriers/80x80/7R.png": 326753,
	"./carriers/80x80/7S.png": 54040,
	"./carriers/80x80/7T.png": 633655,
	"./carriers/80x80/7U.png": 160014,
	"./carriers/80x80/7V.png": 362437,
	"./carriers/80x80/7W.png": 44924,
	"./carriers/80x80/7Y.png": 461570,
	"./carriers/80x80/7Z.png": 975577,
	"./carriers/80x80/8B.png": 647892,
	"./carriers/80x80/8C.png": 564573,
	"./carriers/80x80/8D.png": 376674,
	"./carriers/80x80/8E.png": 597803,
	"./carriers/80x80/8F.png": 226512,
	"./carriers/80x80/8G.png": 232761,
	"./carriers/80x80/8H.png": 900846,
	"./carriers/80x80/8I.png": 846423,
	"./carriers/80x80/8J.png": 588316,
	"./carriers/80x80/8K.png": 671205,
	"./carriers/80x80/8L.png": 787978,
	"./carriers/80x80/8M.png": 943187,
	"./carriers/80x80/8N.png": 597432,
	"./carriers/80x80/8P.png": 744342,
	"./carriers/80x80/8Q.png": 522431,
	"./carriers/80x80/8R.png": 608868,
	"./carriers/80x80/8S.png": 135021,
	"./carriers/80x80/8T.png": 753458,
	"./carriers/80x80/8U.png": 502459,
	"./carriers/80x80/8V.png": 663776,
	"./carriers/80x80/8W.png": 118601,
	"./carriers/80x80/8Y.png": 291047,
	"./carriers/80x80/8Z.png": 422572,
	"./carriers/80x80/9A.png": 496792,
	"./carriers/80x80/9B.png": 671283,
	"./carriers/80x80/9C.png": 820522,
	"./carriers/80x80/9D.png": 805189,
	"./carriers/80x80/9E.png": 487676,
	"./carriers/80x80/9F.png": 76407,
	"./carriers/80x80/9H.png": 418329,
	"./carriers/80x80/9I.png": 702576,
	"./carriers/80x80/9J.png": 667979,
	"./carriers/80x80/9K.png": 904322,
	"./carriers/80x80/9L.png": 597117,
	"./carriers/80x80/9M.png": 375988,
	"./carriers/80x80/9N.png": 298447,
	"./carriers/80x80/9O.png": 529702,
	"./carriers/80x80/9P.png": 957745,
	"./carriers/80x80/9Q.png": 509352,
	"./carriers/80x80/9R.png": 371331,
	"./carriers/80x80/9S.png": 781498,
	"./carriers/80x80/9T.png": 233557,
	"./carriers/80x80/9U.png": 321932,
	"./carriers/80x80/9V.png": 88967,
	"./carriers/80x80/9X.png": 768937,
	"./carriers/80x80/9Y.png": 644736,
	"./carriers/80x80/A0.png": 610409,
	"./carriers/80x80/A1.png": 639232,
	"./carriers/80x80/A2.png": 417563,
	"./carriers/80x80/A3.png": 519698,
	"./carriers/80x80/A4.png": 392205,
	"./carriers/80x80/A5.png": 635908,
	"./carriers/80x80/A6.png": 590559,
	"./carriers/80x80/A7.png": 994230,
	"./carriers/80x80/A8.png": 222513,
	"./carriers/80x80/A9.png": 808296,
	"./carriers/80x80/AA.png": 216848,
	"./carriers/80x80/AB.png": 588139,
	"./carriers/80x80/AC.png": 367010,
	"./carriers/80x80/AD.png": 554909,
	"./carriers/80x80/AE.png": 638228,
	"./carriers/80x80/AF.png": 812719,
	"./carriers/80x80/AG.png": 773702,
	"./carriers/80x80/AH.png": 808897,
	"./carriers/80x80/AI.png": 587768,
	"./carriers/80x80/AJ.png": 933523,
	"./carriers/80x80/AK.png": 778314,
	"./carriers/80x80/AL.png": 661541,
	"./carriers/80x80/AM.png": 578652,
	"./carriers/80x80/AN.png": 836759,
	"./carriers/80x80/AO.png": 891182,
	"./carriers/80x80/AP.png": 108937,
	"./carriers/80x80/AQ.png": 654112,
	"./carriers/80x80/AR.png": 492795,
	"./carriers/80x80/AS.png": 743794,
	"./carriers/80x80/AT.png": 125357,
	"./carriers/80x80/AU.png": 599204,
	"./carriers/80x80/AV.png": 512767,
	"./carriers/80x80/AW.png": 734678,
	"./carriers/80x80/AX.png": 246161,
	"./carriers/80x80/AY.png": 6216,
	"./carriers/80x80/AZ.png": 343075,
	"./carriers/80x80/B0.png": 63572,
	"./carriers/80x80/B2.png": 503494,
	"./carriers/80x80/B3.png": 568687,
	"./carriers/80x80/B4.png": 99664,
	"./carriers/80x80/B5.png": 105913,
	"./carriers/80x80/B6.png": 122978,
	"./carriers/80x80/B7.png": 13483,
	"./carriers/80x80/B8.png": 792092,
	"./carriers/80x80/B9.png": 544357,
	"./carriers/80x80/BA.png": 24717,
	"./carriers/80x80/BB.png": 592950,
	"./carriers/80x80/BC.png": 646751,
	"./carriers/80x80/BD.png": 635072,
	"./carriers/80x80/BE.png": 759273,
	"./carriers/80x80/BF.png": 694738,
	"./carriers/80x80/BG.png": 16283,
	"./carriers/80x80/BH.png": 312268,
	"./carriers/80x80/BI.png": 223893,
	"./carriers/80x80/BJ.png": 903518,
	"./carriers/80x80/BK.png": 79303,
	"./carriers/80x80/BL.png": 499688,
	"./carriers/80x80/BM.png": 948081,
	"./carriers/80x80/BN.png": 771834,
	"./carriers/80x80/BO.png": 361667,
	"./carriers/80x80/BP.png": 366324,
	"./carriers/80x80/BQ.png": 587453,
	"./carriers/80x80/BR.png": 520038,
	"./carriers/80x80/BS.png": 288783,
	"./carriers/80x80/BT.png": 692912,
	"./carriers/80x80/BU.png": 408665,
	"./carriers/80x80/BV.png": 894658,
	"./carriers/80x80/BW.png": 658315,
	"./carriers/80x80/BX.png": 478012,
	"./carriers/80x80/BY.png": 795525,
	"./carriers/80x80/BZ.png": 593102,
	"./carriers/80x80/C0.png": 813823,
	"./carriers/80x80/C2.png": 730861,
	"./carriers/80x80/C3.png": 476964,
	"./carriers/80x80/C4.png": 640827,
	"./carriers/80x80/C5.png": 926002,
	"./carriers/80x80/C6.png": 740617,
	"./carriers/80x80/C7.png": 862496,
	"./carriers/80x80/C8.png": 463591,
	"./carriers/80x80/C9.png": 711102,
	"./carriers/80x80/CA.png": 972454,
	"./carriers/80x80/CC.png": 818740,
	"./carriers/80x80/CD.png": 110731,
	"./carriers/80x80/CE.png": 347074,
	"./carriers/80x80/CF.png": 861081,
	"./carriers/80x80/CG.png": 145328,
	"./carriers/80x80/CH.png": 519159,
	"./carriers/80x80/CI.png": 45518,
	"./carriers/80x80/CJ.png": 247941,
	"./carriers/80x80/CK.png": 930428,
	"./carriers/80x80/CL.png": 114035,
	"./carriers/80x80/CM.png": 263274,
	"./carriers/80x80/CN.png": 212257,
	"./carriers/80x80/CO.png": 939544,
	"./carriers/80x80/CP.png": 99167,
	"./carriers/80x80/CQ.png": 561718,
	"./carriers/80x80/CS.png": 813892,
	"./carriers/80x80/CT.png": 468699,
	"./carriers/80x80/CU.png": 147154,
	"./carriers/80x80/CV.png": 211689,
	"./carriers/80x80/CW.png": 87488,
	"./carriers/80x80/CX.png": 531719,
	"./carriers/80x80/CY.png": 355934,
	"./carriers/80x80/CZ.png": 676309,
	"./carriers/80x80/D0.png": 916338,
	"./carriers/80x80/D2.png": 852832,
	"./carriers/80x80/D3.png": 730953,
	"./carriers/80x80/D4.png": 390870,
	"./carriers/80x80/D5.png": 804159,
	"./carriers/80x80/D6.png": 467300,
	"./carriers/80x80/D7.png": 721197,
	"./carriers/80x80/D8.png": 963418,
	"./carriers/80x80/D9.png": 211171,
	"./carriers/80x80/DC.png": 851417,
	"./carriers/80x80/DD.png": 962790,
	"./carriers/80x80/DE.png": 731535,
	"./carriers/80x80/DF.png": 809076,
	"./carriers/80x80/DG.png": 30205,
	"./carriers/80x80/DH.png": 253610,
	"./carriers/80x80/DI.png": 104371,
	"./carriers/80x80/DJ.png": 929880,
	"./carriers/80x80/DK.png": 202593,
	"./carriers/80x80/DL.png": 35854,
	"./carriers/80x80/DM.png": 509495,
	"./carriers/80x80/DN.png": 920764,
	"./carriers/80x80/DO.png": 238277,
	"./carriers/80x80/DP.png": 137490,
	"./carriers/80x80/DQ.png": 459035,
	"./carriers/80x80/DR.png": 77824,
	"./carriers/80x80/DS.png": 202025,
	"./carriers/80x80/DT.png": 552054,
	"./carriers/80x80/DU.png": 89503,
	"./carriers/80x80/DV.png": 804228,
	"./carriers/80x80/DW.png": 467469,
	"./carriers/80x80/DX.png": 214586,
	"./carriers/80x80/DY.png": 804419,
	"./carriers/80x80/DZ.png": 942440,
	"./carriers/80x80/E2.png": 183951,
	"./carriers/80x80/E3.png": 415206,
	"./carriers/80x80/E4.png": 303833,
	"./carriers/80x80/E5.png": 588080,
	"./carriers/80x80/E6.png": 553483,
	"./carriers/80x80/E7.png": 789826,
	"./carriers/80x80/E8.png": 690693,
	"./carriers/80x80/E9.png": 373180,
	"./carriers/80x80/EB.png": 256575,
	"./carriers/80x80/EC.png": 843286,
	"./carriers/80x80/ED.png": 183369,
	"./carriers/80x80/EE.png": 305248,
	"./carriers/80x80/EF.png": 83579,
	"./carriers/80x80/EG.png": 368754,
	"./carriers/80x80/EH.png": 239605,
	"./carriers/80x80/EI.png": 487340,
	"./carriers/80x80/EJ.png": 906343,
	"./carriers/80x80/EK.png": 153854,
	"./carriers/80x80/EL.png": 320593,
	"./carriers/80x80/EM.png": 326728,
	"./carriers/80x80/EN.png": 663587,
	"./carriers/80x80/EO.png": 415834,
	"./carriers/80x80/EP.png": 179869,
	"./carriers/80x80/EQ.png": 958740,
	"./carriers/80x80/ER.png": 463855,
	"./carriers/80x80/ES.png": 398662,
	"./carriers/80x80/ET.png": 1081,
	"./carriers/80x80/EU.png": 994832,
	"./carriers/80x80/EV.png": 908651,
	"./carriers/80x80/EW.png": 18146,
	"./carriers/80x80/EX.png": 439525,
	"./carriers/80x80/EY.png": 687260,
	"./carriers/80x80/EZ.png": 911191,
	"./carriers/80x80/F0.png": 387768,
	"./carriers/80x80/F2.png": 578314,
	"./carriers/80x80/F3.png": 733523,
	"./carriers/80x80/F4.png": 378652,
	"./carriers/80x80/F5.png": 461541,
	"./carriers/80x80/F6.png": 691182,
	"./carriers/80x80/F7.png": 636759,
	"./carriers/80x80/F8.png": 16848,
	"./carriers/80x80/F9.png": 23097,
	"./carriers/80x80/FA.png": 22513,
	"./carriers/80x80/FB.png": 92346,
	"./carriers/80x80/FC.png": 409923,
	"./carriers/80x80/FD.png": 479756,
	"./carriers/80x80/FE.png": 848853,
	"./carriers/80x80/FF.png": 681502,
	"./carriers/80x80/FG.png": 399815,
	"./carriers/80x80/FH.png": 955584,
	"./carriers/80x80/FI.png": 410409,
	"./carriers/80x80/FJ.png": 319698,
	"./carriers/80x80/FK.png": 217563,
	"./carriers/80x80/FL.png": 952260,
	"./carriers/80x80/FM.png": 192205,
	"./carriers/80x80/FN.png": 310582,
	"./carriers/80x80/FO.png": 390559,
	"./carriers/80x80/FP.png": 112088,
	"./carriers/80x80/FQ.png": 80353,
	"./carriers/80x80/FR.png": 131370,
	"./carriers/80x80/FS.png": 286579,
	"./carriers/80x80/FT.png": 102972,
	"./carriers/80x80/FU.png": 116037,
	"./carriers/80x80/FV.png": 244238,
	"./carriers/80x80/FW.png": 387255,
	"./carriers/80x80/FX.png": 436720,
	"./carriers/80x80/FY.png": 33625,
	"./carriers/80x80/FZ.png": 485442,
	"./carriers/80x80/G0.png": 595491,
	"./carriers/80x80/G2.png": 498577,
	"./carriers/80x80/G3.png": 258632,
	"./carriers/80x80/G4.png": 533799,
	"./carriers/80x80/G5.png": 662462,
	"./carriers/80x80/G6.png": 748213,
	"./carriers/80x80/G7.png": 665324,
	"./carriers/80x80/G8.png": 261563,
	"./carriers/80x80/G9.png": 996210,
	"./carriers/80x80/GA.png": 583786,
	"./carriers/80x80/GB.png": 532769,
	"./carriers/80x80/GC.png": 564504,
	"./carriers/80x80/GD.png": 839671,
	"./carriers/80x80/GE.png": 696654,
	"./carriers/80x80/GF.png": 568453,
	"./carriers/80x80/GH.png": 158987,
	"./carriers/80x80/GI.png": 937858,
	"./carriers/80x80/GJ.png": 486041,
	"./carriers/80x80/GK.png": 889136,
	"./carriers/80x80/GL.png": 331983,
	"./carriers/80x80/GM.png": 292966,
	"./carriers/80x80/GO.png": 113076,
	"./carriers/80x80/GP.png": 862339,
	"./carriers/80x80/GQ.png": 544762,
	"./carriers/80x80/GR.png": 474929,
	"./carriers/80x80/GS.png": 60712,
	"./carriers/80x80/GT.png": 852231,
	"./carriers/80x80/GU.png": 133918,
	"./carriers/80x80/GV.png": 301269,
	"./carriers/80x80/GW.png": 932172,
	"./carriers/80x80/GX.png": 669979,
	"./carriers/80x80/GY.png": 772114,
	"./carriers/80x80/GZ.png": 862825,
	"./carriers/80x80/H1.png": 55471,
	"./carriers/80x80/H2.png": 880980,
	"./carriers/80x80/H3.png": 314013,
	"./carriers/80x80/H4.png": 609762,
	"./carriers/80x80/H5.png": 830891,
	"./carriers/80x80/H6.png": 459600,
	"./carriers/80x80/H7.png": 465849,
	"./carriers/80x80/H8.png": 133934,
	"./carriers/80x80/H9.png": 79511,
	"./carriers/80x80/HA.png": 833311,
	"./carriers/80x80/HB.png": 395012,
	"./carriers/80x80/HC.png": 634957,
	"./carriers/80x80/HD.png": 762450,
	"./carriers/80x80/HF.png": 398336,
	"./carriers/80x80/HH.png": 124254,
	"./carriers/80x80/HJ.png": 922508,
	"./carriers/80x80/HK.png": 291605,
	"./carriers/80x80/HM.png": 852675,
	"./carriers/80x80/HN.png": 51048,
	"./carriers/80x80/HO.png": 465265,
	"./carriers/80x80/HP.png": 283302,
	"./carriers/80x80/HQ.png": 322319,
	"./carriers/80x80/HR.png": 103412,
	"./carriers/80x80/HS.png": 324541,
	"./carriers/80x80/HT.png": 928194,
	"./carriers/80x80/HU.png": 149323,
	"./carriers/80x80/HV.png": 879472,
	"./carriers/80x80/HW.png": 476377,
	"./carriers/80x80/HX.png": 686990,
	"./carriers/80x80/HY.png": 830007,
	"./carriers/80x80/HZ.png": 545724,
	"./carriers/80x80/I2.png": 24499,
	"./carriers/80x80/I3.png": 869290,
	"./carriers/80x80/I4.png": 853957,
	"./carriers/80x80/I5.png": 324540,
	"./carriers/80x80/I6.png": 125175,
	"./carriers/80x80/I7.png": 982158,
	"./carriers/80x80/I8.png": 771545,
	"./carriers/80x80/I9.png": 174640,
	"./carriers/80x80/IA.png": 544136,
	"./carriers/80x80/IB.png": 880995,
	"./carriers/80x80/IC.png": 659418,
	"./carriers/80x80/ID.png": 33717,
	"./carriers/80x80/IE.png": 950828,
	"./carriers/80x80/IF.png": 819303,
	"./carriers/80x80/IG.png": 947966,
	"./carriers/80x80/IH.png": 646857,
	"./carriers/80x80/II.png": 192032,
	"./carriers/80x80/IJ.png": 30715,
	"./carriers/80x80/IK.png": 281714,
	"./carriers/80x80/IL.png": 663277,
	"./carriers/80x80/IM.png": 137124,
	"./carriers/80x80/IN.png": 50687,
	"./carriers/80x80/IO.png": 272598,
	"./carriers/80x80/IP.png": 346817,
	"./carriers/80x80/IQ.png": 125688,
	"./carriers/80x80/IR.png": 471443,
	"./carriers/80x80/IS.png": 316234,
	"./carriers/80x80/IT.png": 683109,
	"./carriers/80x80/IU.png": 116572,
	"./carriers/80x80/IV.png": 858327,
	"./carriers/80x80/IW.png": 429102,
	"./carriers/80x80/IX.png": 761017,
	"./carriers/80x80/IY.png": 754768,
	"./carriers/80x80/IZ.png": 126059,
	"./carriers/80x80/J0.png": 670092,
	"./carriers/80x80/J1.png": 39189,
	"./carriers/80x80/J2.png": 871838,
	"./carriers/80x80/J3.png": 590151,
	"./carriers/80x80/J4.png": 798632,
	"./carriers/80x80/J5.png": 212849,
	"./carriers/80x80/J6.png": 282682,
	"./carriers/80x80/J7.png": 83907,
	"./carriers/80x80/J8.png": 626244,
	"./carriers/80x80/J9.png": 382541,
	"./carriers/80x80/JA.png": 651877,
	"./carriers/80x80/JB.png": 881518,
	"./carriers/80x80/JC.png": 827095,
	"./carriers/80x80/JD.png": 578104,
	"./carriers/80x80/JE.png": 799233,
	"./carriers/80x80/JF.png": 768650,
	"./carriers/80x80/JG.png": 923859,
	"./carriers/80x80/JH.png": 628564,
	"./carriers/80x80/JI.png": 545245,
	"./carriers/80x80/JJ.png": 764038,
	"./carriers/80x80/JK.png": 803055,
	"./carriers/80x80/JL.png": 207184,
	"./carriers/80x80/JM.png": 213433,
	"./carriers/80x80/JO.png": 578475,
	"./carriers/80x80/JP.png": 403244,
	"./carriers/80x80/JQ.png": 486133,
	"./carriers/80x80/JR.png": 400382,
	"./carriers/80x80/JS.png": 271719,
	"./carriers/80x80/JT.png": 996552,
	"./carriers/80x80/JU.png": 236497,
	"./carriers/80x80/JV.png": 111834,
	"./carriers/80x80/JX.png": 589540,
	"./carriers/80x80/JY.png": 115693,
	"./carriers/80x80/JZ.png": 725014,
	"./carriers/80x80/K1.png": 306862,
	"./carriers/80x80/K2.png": 534693,
	"./carriers/80x80/K3.png": 782428,
	"./carriers/80x80/K4.png": 679827,
	"./carriers/80x80/K6.png": 105345,
	"./carriers/80x80/K7.png": 884216,
	"./carriers/80x80/K8.png": 559023,
	"./carriers/80x80/K9.png": 493830,
	"./carriers/80x80/KA.png": 893854,
	"./carriers/80x80/KB.png": 214229,
	"./carriers/80x80/KC.png": 302604,
	"./carriers/80x80/KD.png": 352003,
	"./carriers/80x80/KE.png": 762170,
	"./carriers/80x80/KF.png": 938417,
	"./carriers/80x80/KG.png": 490024,
	"./carriers/80x80/KH.png": 637087,
	"./carriers/80x80/KI.png": 583286,
	"./carriers/80x80/KJ.png": 15053,
	"./carriers/80x80/KK.png": 351812,
	"./carriers/80x80/KL.png": 6619,
	"./carriers/80x80/KM.png": 685074,
	"./carriers/80x80/KN.png": 749609,
	"./carriers/80x80/KO.png": 625408,
	"./carriers/80x80/KP.png": 57079,
	"./carriers/80x80/KQ.png": 583438,
	"./carriers/80x80/KR.png": 785861,
	"./carriers/80x80/KS.png": 468348,
	"./carriers/80x80/KT.png": 651955,
	"./carriers/80x80/KU.png": 801194,
	"./carriers/80x80/KV.png": 750177,
	"./carriers/80x80/KW.png": 477464,
	"./carriers/80x80/KX.png": 279119,
	"./carriers/80x80/KY.png": 510374,
	"./carriers/80x80/KZ.png": 577789,
	"./carriers/80x80/L2.png": 874552,
	"./carriers/80x80/L3.png": 95681,
	"./carriers/80x80/L5.png": 996695,
	"./carriers/80x80/L6.png": 772764,
	"./carriers/80x80/L7.png": 525029,
	"./carriers/80x80/L8.png": 103650,
	"./carriers/80x80/L9.png": 994155,
	"./carriers/80x80/LA.png": 342339,
	"./carriers/80x80/LB.png": 480360,
	"./carriers/80x80/LC.png": 928753,
	"./carriers/80x80/LD.png": 884190,
	"./carriers/80x80/LE.png": 59975,
	"./carriers/80x80/LF.png": 292940,
	"./carriers/80x80/LG.png": 204565,
	"./carriers/80x80/LH.png": 675410,
	"./carriers/80x80/LI.png": 996955,
	"./carriers/80x80/LJ.png": 615744,
	"./carriers/80x80/LK.png": 739945,
	"./carriers/80x80/LL.png": 573622,
	"./carriers/80x80/LM.png": 627423,
	"./carriers/80x80/LN.png": 342148,
	"./carriers/80x80/LO.png": 5389,
	"./carriers/80x80/LP.png": 791530,
	"./carriers/80x80/LQ.png": 642291,
	"./carriers/80x80/LR.png": 467800,
	"./carriers/80x80/LS.png": 740513,
	"./carriers/80x80/LT.png": 573774,
	"./carriers/80x80/LU.png": 47415,
	"./carriers/80x80/LV.png": 458684,
	"./carriers/80x80/LW.png": 776197,
	"./carriers/80x80/LX.png": 875330,
	"./carriers/80x80/LY.png": 638987,
	"./carriers/80x80/LZ.png": 673584,
	"./carriers/80x80/M0.png": 777525,
	"./carriers/80x80/M2.png": 444263,
	"./carriers/80x80/M3.png": 691774,
	"./carriers/80x80/M4.png": 858513,
	"./carriers/80x80/M5.png": 864648,
	"./carriers/80x80/M6.png": 201507,
	"./carriers/80x80/M7.png": 953754,
	"./carriers/80x80/M8.png": 711533,
	"./carriers/80x80/M9.png": 457636,
	"./carriers/80x80/MB.png": 499831,
	"./carriers/80x80/MD.png": 192929,
	"./carriers/80x80/ME.png": 920216,
	"./carriers/80x80/MF.png": 94707,
	"./carriers/80x80/MG.png": 243946,
	"./carriers/80x80/MH.png": 20541,
	"./carriers/80x80/MI.png": 799412,
	"./carriers/80x80/MJ.png": 721871,
	"./carriers/80x80/MK.png": 953126,
	"./carriers/80x80/ML.png": 841753,
	"./carriers/80x80/MM.png": 126000,
	"./carriers/80x80/MN.png": 91403,
	"./carriers/80x80/MO.png": 327746,
	"./carriers/80x80/MP.png": 656981,
	"./carriers/80x80/MQ.png": 745356,
	"./carriers/80x80/MR.png": 512391,
	"./carriers/80x80/MS.png": 336606,
	"./carriers/80x80/MT.png": 381169,
	"./carriers/80x80/MU.png": 932776,
	"./carriers/80x80/MV.png": 794755,
	"./carriers/80x80/MW.png": 204922,
	"./carriers/80x80/MX.png": 457805,
	"./carriers/80x80/MY.png": 794564,
	"./carriers/80x80/MZ.png": 79839,
	"./carriers/80x80/N0.png": 578416,
	"./carriers/80x80/N2.png": 780162,
	"./carriers/80x80/N3.png": 543819,
	"./carriers/80x80/N4.png": 251828,
	"./carriers/80x80/N5.png": 472957,
	"./carriers/80x80/N7.png": 174287,
	"./carriers/80x80/N8.png": 372632,
	"./carriers/80x80/N9.png": 645345,
	"./carriers/80x80/NA.png": 173705,
	"./carriers/80x80/NB.png": 359090,
	"./carriers/80x80/NC.png": 73915,
	"./carriers/80x80/ND.png": 910052,
	"./carriers/80x80/NE.png": 163949,
	"./carriers/80x80/NF.png": 833622,
	"./carriers/80x80/NG.png": 246911,
	"./carriers/80x80/NH.png": 317064,
	"./carriers/80x80/NI.png": 310929,
	"./carriers/80x80/NJ.png": 406170,
	"./carriers/80x80/NK.png": 653923,
	"./carriers/80x80/NL.png": 477676,
	"./carriers/80x80/NM.png": 229941,
	"./carriers/80x80/NN.png": 144190,
	"./carriers/80x80/NO.png": 896679,
	"./carriers/80x80/NP.png": 985168,
	"./carriers/80x80/NQ.png": 991417,
	"./carriers/80x80/NR.png": 8482,
	"./carriers/80x80/NS.png": 898987,
	"./carriers/80x80/NT.png": 949076,
	"./carriers/80x80/NU.png": 170205,
	"./carriers/80x80/NV.png": 388998,
	"./carriers/80x80/NX.png": 779384,
	"./carriers/80x80/NY.png": 513,
	"./carriers/80x80/NZ.png": 359434,
	"./carriers/80x80/O3.png": 972992,
	"./carriers/80x80/O4.png": 501023,
	"./carriers/80x80/O7.png": 699396,
	"./carriers/80x80/O9.png": 109754,
	"./carriers/80x80/OA.png": 460898,
	"./carriers/80x80/OB.png": 443833,
	"./carriers/80x80/OC.png": 437584,
	"./carriers/80x80/OD.png": 906607,
	"./carriers/80x80/OE.png": 841414,
	"./carriers/80x80/OF.png": 622621,
	"./carriers/80x80/OG.png": 401492,
	"./carriers/80x80/OH.png": 27411,
	"./carriers/80x80/OI.png": 811850,
	"./carriers/80x80/OJ.png": 452929,
	"./carriers/80x80/OK.png": 231800,
	"./carriers/80x80/OL.png": 353943,
	"./carriers/80x80/OM.png": 654446,
	"./carriers/80x80/ON.png": 882277,
	"./carriers/80x80/OO.png": 130012,
	"./carriers/80x80/OP.png": 526331,
	"./carriers/80x80/OQ.png": 811506,
	"./carriers/80x80/OR.png": 626121,
	"./carriers/80x80/OS.png": 748000,
	"./carriers/80x80/OT.png": 699327,
	"./carriers/80x80/OU.png": 286038,
	"./carriers/80x80/OV.png": 616365,
	"./carriers/80x80/OW.png": 362468,
	"./carriers/80x80/OY.png": 858586,
	"./carriers/80x80/OZ.png": 763345,
	"./carriers/80x80/P0.png": 231774,
	"./carriers/80x80/P1.png": 407559,
	"./carriers/80x80/P2.png": 640524,
	"./carriers/80x80/P3.png": 552149,
	"./carriers/80x80/P4.png": 100090,
	"./carriers/80x80/P5.png": 689923,
	"./carriers/80x80/P6.png": 827944,
	"./carriers/80x80/P7.png": 276337,
	"./carriers/80x80/P8.png": 437558,
	"./carriers/80x80/P9.png": 491359,
	"./carriers/80x80/PA.png": 344279,
	"./carriers/80x80/PB.png": 120348,
	"./carriers/80x80/PC.png": 872613,
	"./carriers/80x80/PD.png": 802186,
	"./carriers/80x80/PE.png": 17747,
	"./carriers/80x80/PF.png": 222136,
	"./carriers/80x80/PG.png": 443265,
	"./carriers/80x80/PH.png": 831750,
	"./carriers/80x80/PI.png": 896943,
	"./carriers/80x80/PJ.png": 391828,
	"./carriers/80x80/PK.png": 612957,
	"./carriers/80x80/PL.png": 451234,
	"./carriers/80x80/PM.png": 341739,
	"./carriers/80x80/PN.png": 427920,
	"./carriers/80x80/PO.png": 434169,
	"./carriers/80x80/PQ.png": 339431,
	"./carriers/80x80/PR.png": 920428,
	"./carriers/80x80/PS.png": 672693,
	"./carriers/80x80/PT.png": 848922,
	"./carriers/80x80/PU.png": 96675,
	"./carriers/80x80/PV.png": 759816,
	"./carriers/80x80/PW.png": 753681,
	"./carriers/80x80/PX.png": 792726,
	"./carriers/80x80/PY.png": 689663,
	"./carriers/80x80/PZ.png": 352804,
	"./carriers/80x80/Q2.png": 821227,
	"./carriers/80x80/Q3.png": 600098,
	"./carriers/80x80/Q4.png": 304349,
	"./carriers/80x80/Q5.png": 871316,
	"./carriers/80x80/Q6.png": 45807,
	"./carriers/80x80/Q7.png": 6790,
	"./carriers/80x80/Q8.png": 41985,
	"./carriers/80x80/Q9.png": 820856,
	"./carriers/80x80/QA.png": 388672,
	"./carriers/80x80/QB.png": 650651,
	"./carriers/80x80/QC.png": 752786,
	"./carriers/80x80/QD.png": 625293,
	"./carriers/80x80/QE.png": 385348,
	"./carriers/80x80/QF.png": 823647,
	"./carriers/80x80/QG.png": 743670,
	"./carriers/80x80/QH.png": 455601,
	"./carriers/80x80/QI.png": 41384,
	"./carriers/80x80/QK.png": 525434,
	"./carriers/80x80/QL.png": 281941,
	"./carriers/80x80/QM.png": 912844,
	"./carriers/80x80/QN.png": 832903,
	"./carriers/80x80/QO.png": 114590,
	"./carriers/80x80/QP.png": 466713,
	"./carriers/80x80/QQ.png": 869808,
	"./carriers/80x80/QR.png": 139659,
	"./carriers/80x80/QS.png": 918530,
	"./carriers/80x80/QT.png": 314877,
	"./carriers/80x80/QU.png": 93748,
	"./carriers/80x80/QV.png": 312655,
	"./carriers/80x80/QW.png": 273638,
	"./carriers/80x80/QX.png": 513441,
	"./carriers/80x80/QY.png": 545176,
	"./carriers/80x80/QZ.png": 719667,
	"./carriers/80x80/R0.png": 284708,
	"./carriers/80x80/R2.png": 420182,
	"./carriers/80x80/R3.png": 198271,
	"./carriers/80x80/R4.png": 339616,
	"./carriers/80x80/R5.png": 794441,
	"./carriers/80x80/R6.png": 429298,
	"./carriers/80x80/R7.png": 694651,
	"./carriers/80x80/R9.png": 181301,
	"./carriers/80x80/RA.png": 767293,
	"./carriers/80x80/RB.png": 726054,
	"./carriers/80x80/RC.png": 765071,
	"./carriers/80x80/RD.png": 322224,
	"./carriers/80x80/RE.png": 919129,
	"./carriers/80x80/RF.png": 370946,
	"./carriers/80x80/RG.png": 592075,
	"./carriers/80x80/RH.png": 988476,
	"./carriers/80x80/RI.png": 1541,
	"./carriers/80x80/RJ.png": 129742,
	"./carriers/80x80/RK.png": 272759,
	"./carriers/80x80/RL.png": 997592,
	"./carriers/80x80/RM.png": 965857,
	"./carriers/80x80/RN.png": 16874,
	"./carriers/80x80/RO.png": 172083,
	"./carriers/80x80/RP.png": 837764,
	"./carriers/80x80/RQ.png": 77709,
	"./carriers/80x80/RR.png": 196086,
	"./carriers/80x80/RS.png": 792415,
	"./carriers/80x80/RT.png": 841088,
	"./carriers/80x80/RU.png": 295913,
	"./carriers/80x80/RV.png": 205202,
	"./carriers/80x80/RW.png": 103067,
	"./carriers/80x80/RX.png": 365260,
	"./carriers/80x80/RY.png": 734357,
	"./carriers/80x80/RZ.png": 567006,
	"./carriers/80x80/S0.png": 543887,
	"./carriers/80x80/S1.png": 21222,
	"./carriers/80x80/S2.png": 546109,
	"./carriers/80x80/S4.png": 370891,
	"./carriers/80x80/S5.png": 149762,
	"./carriers/80x80/S6.png": 214297,
	"./carriers/80x80/S7.png": 617392,
	"./carriers/80x80/S8.png": 567927,
	"./carriers/80x80/S9.png": 424910,
	"./carriers/80x80/SA.png": 715350,
	"./carriers/80x80/SB.png": 106029,
	"./carriers/80x80/SC.png": 579876,
	"./carriers/80x80/SD.png": 473467,
	"./carriers/80x80/SE.png": 724466,
	"./carriers/80x80/SF.png": 89609,
	"./carriers/80x80/SG.png": 634784,
	"./carriers/80x80/SH.png": 262055,
	"./carriers/80x80/SI.png": 390718,
	"./carriers/80x80/SJ.png": 476469,
	"./carriers/80x80/SK.png": 393580,
	"./carriers/80x80/SL.png": 323747,
	"./carriers/80x80/SM.png": 102170,
	"./carriers/80x80/SN.png": 226833,
	"./carriers/80x80/SO.png": 986888,
	"./carriers/80x80/SP.png": 793391,
	"./carriers/80x80/SQ.png": 754374,
	"./carriers/80x80/SR.png": 535581,
	"./carriers/80x80/SS.png": 618900,
	"./carriers/80x80/ST.png": 568811,
	"./carriers/80x80/SU.png": 347682,
	"./carriers/80x80/SV.png": 203769,
	"./carriers/80x80/SW.png": 197520,
	"./carriers/80x80/SX.png": 817431,
	"./carriers/80x80/SY.png": 871854,
	"./carriers/80x80/SZ.png": 642213,
	"./carriers/80x80/T0.png": 140098,
	"./carriers/80x80/T2.png": 607728,
	"./carriers/80x80/T3.png": 204633,
	"./carriers/80x80/T4.png": 11558,
	"./carriers/80x80/T5.png": 50575,
	"./carriers/80x80/T6.png": 315316,
	"./carriers/80x80/T7.png": 536445,
	"./carriers/80x80/T9.png": 457587,
	"./carriers/80x80/TA.png": 463803,
	"./carriers/80x80/TB.png": 625120,
	"./carriers/80x80/TC.png": 79945,
	"./carriers/80x80/TD.png": 705686,
	"./carriers/80x80/TE.png": 483775,
	"./carriers/80x80/TF.png": 570212,
	"./carriers/80x80/TG.png": 96365,
	"./carriers/80x80/TH.png": 92506,
	"./carriers/80x80/TI.png": 314083,
	"./carriers/80x80/TJ.png": 977224,
	"./carriers/80x80/TK.png": 217169,
	"./carriers/80x80/TL.png": 381054,
	"./carriers/80x80/TM.png": 252391,
	"./carriers/80x80/TN.png": 383916,
	"./carriers/80x80/TO.png": 466805,
	"./carriers/80x80/TP.png": 338018,
	"./carriers/80x80/TQ.png": 559147,
	"./carriers/80x80/TR.png": 187856,
	"./carriers/80x80/TS.png": 194105,
	"./carriers/80x80/TT.png": 744710,
	"./carriers/80x80/TU.png": 783727,
	"./carriers/80x80/TV.png": 609236,
	"./carriers/80x80/TW.png": 525917,
	"./carriers/80x80/TX.png": 749322,
	"./carriers/80x80/TY.png": 904531,
	"./carriers/80x80/TZ.png": 558776,
	"./carriers/80x80/U0.png": 815629,
	"./carriers/80x80/U2.png": 13983,
	"./carriers/80x80/U3.png": 934006,
	"./carriers/80x80/U4.png": 33833,
	"./carriers/80x80/U5.png": 62656,
	"./carriers/80x80/U6.png": 840987,
	"./carriers/80x80/U7.png": 943122,
	"./carriers/80x80/U8.png": 472277,
	"./carriers/80x80/UA.png": 61652,
	"./carriers/80x80/UB.png": 236143,
	"./carriers/80x80/UC.png": 197126,
	"./carriers/80x80/UD.png": 646521,
	"./carriers/80x80/UE.png": 640272,
	"./carriers/80x80/UF.png": 11563,
	"./carriers/80x80/UG.png": 790434,
	"./carriers/80x80/UH.png": 84965,
	"./carriers/80x80/UI.png": 2076,
	"./carriers/80x80/UJ.png": 260183,
	"./carriers/80x80/UK.png": 314606,
	"./carriers/80x80/UL.png": 232321,
	"./carriers/80x80/UM.png": 11192,
	"./carriers/80x80/UN.png": 356947,
	"./carriers/80x80/UO.png": 201738,
	"./carriers/80x80/UP.png": 548781,
	"./carriers/80x80/UQ.png": 22628,
	"./carriers/80x80/UR.png": 936191,
	"./carriers/80x80/US.png": 935721,
	"./carriers/80x80/UT.png": 532361,
	"./carriers/80x80/UU.png": 77536,
	"./carriers/80x80/UX.png": 919221,
	"./carriers/80x80/UY.png": 836332,
	"./carriers/80x80/UZ.png": 704807,
	"./carriers/80x80/V0.png": 854984,
	"./carriers/80x80/V2.png": 944090,
	"./carriers/80x80/V3.png": 191843,
	"./carriers/80x80/V4.png": 15596,
	"./carriers/80x80/V5.png": 767861,
	"./carriers/80x80/V6.png": 682110,
	"./carriers/80x80/V7.png": 434599,
	"./carriers/80x80/V8.png": 833504,
	"./carriers/80x80/V9.png": 711625,
	"./carriers/80x80/VA.png": 183265,
	"./carriers/80x80/VB.png": 234282,
	"./carriers/80x80/VC.png": 85043,
	"./carriers/80x80/VD.png": 901436,
	"./carriers/80x80/VE.png": 218949,
	"./carriers/80x80/VF.png": 16526,
	"./carriers/80x80/VH.png": 116336,
	"./carriers/80x80/VI.png": 832089,
	"./carriers/80x80/VJ.png": 318082,
	"./carriers/80x80/VK.png": 81739,
	"./carriers/80x80/VL.png": 789748,
	"./carriers/80x80/VM.png": 10877,
	"./carriers/80x80/VN.png": 943462,
	"./carriers/80x80/VO.png": 712207,
	"./carriers/80x80/VP.png": 923112,
	"./carriers/80x80/VQ.png": 371505,
	"./carriers/80x80/VR.png": 195258,
	"./carriers/80x80/VS.png": 785091,
	"./carriers/80x80/VT.png": 735692,
	"./carriers/80x80/VU.png": 647317,
	"./carriers/80x80/VV.png": 326942,
	"./carriers/80x80/VW.png": 502727,
	"./carriers/80x80/VY.png": 182697,
	"./carriers/80x80/VZ.png": 118162,
	"./carriers/80x80/W2.png": 635681,
	"./carriers/80x80/W3.png": 362968,
	"./carriers/80x80/W4.png": 942583,
	"./carriers/80x80/W5.png": 468942,
	"./carriers/80x80/W6.png": 671365,
	"./carriers/80x80/W7.png": 353852,
	"./carriers/80x80/W8.png": 534155,
	"./carriers/80x80/W9.png": 770498,
	"./carriers/80x80/WA.png": 396506,
	"./carriers/80x80/WB.png": 301265,
	"./carriers/80x80/WC.png": 307400,
	"./carriers/80x80/WD.png": 887015,
	"./carriers/80x80/WE.png": 134526,
	"./carriers/80x80/WF.png": 220277,
	"./carriers/80x80/WG.png": 468012,
	"./carriers/80x80/WH.png": 64251,
	"./carriers/80x80/WI.png": 349426,
	"./carriers/80x80/WJ.png": 164041,
	"./carriers/80x80/WK.png": 285920,
	"./carriers/80x80/WL.png": 237247,
	"./carriers/80x80/WM.png": 823958,
	"./carriers/80x80/WN.png": 154285,
	"./carriers/80x80/WO.png": 900388,
	"./carriers/80x80/WP.png": 565331,
	"./carriers/80x80/WQ.png": 349770,
	"./carriers/80x80/WR.png": 990849,
	"./carriers/80x80/WS.png": 769720,
	"./carriers/80x80/WT.png": 891863,
	"./carriers/80x80/WU.png": 192366,
	"./carriers/80x80/WV.png": 420197,
	"./carriers/80x80/WW.png": 667932,
	"./carriers/80x80/WX.png": 889323,
	"./carriers/80x80/WY.png": 998818,
	"./carriers/80x80/WZ.png": 981753,
	"./carriers/80x80/X3.png": 144621,
	"./carriers/80x80/X4.png": 339762,
	"./carriers/80x80/X5.png": 54587,
	"./carriers/80x80/X6.png": 276256,
	"./carriers/80x80/X7.png": 154377,
	"./carriers/80x80/X8.png": 124862,
	"./carriers/80x80/X9.png": 877351,
	"./carriers/80x80/XC.png": 453629,
	"./carriers/80x80/XE.png": 524491,
	"./carriers/80x80/XF.png": 559088,
	"./carriers/80x80/XG.png": 274841,
	"./carriers/80x80/XJ.png": 344188,
	"./carriers/80x80/XK.png": 661701,
	"./carriers/80x80/XL.png": 677034,
	"./carriers/80x80/XM.png": 527795,
	"./carriers/80x80/XN.png": 353304,
	"./carriers/80x80/XO.png": 626017,
	"./carriers/80x80/XP.png": 975478,
	"./carriers/80x80/XQ.png": 29279,
	"./carriers/80x80/XR.png": 227652,
	"./carriers/80x80/XT.png": 560914,
	"./carriers/80x80/XU.png": 882459,
	"./carriers/80x80/XW.png": 625449,
	"./carriers/80x80/XY.png": 945479,
	"./carriers/80x80/XZ.png": 178444,
	"./carriers/80x80/Y2.png": 680259,
	"./carriers/80x80/Y3.png": 90426,
	"./carriers/80x80/Y4.png": 542485,
	"./carriers/80x80/Y5.png": 630860,
	"./carriers/80x80/Y6.png": 397895,
	"./carriers/80x80/Y7.png": 222110,
	"./carriers/80x80/Y8.png": 77865,
	"./carriers/80x80/Y9.png": 953664,
	"./carriers/80x80/YB.png": 8083,
	"./carriers/80x80/YC.png": 792522,
	"./carriers/80x80/YD.png": 862949,
	"./carriers/80x80/YE.png": 110684,
	"./carriers/80x80/YG.png": 635118,
	"./carriers/80x80/YH.png": 424505,
	"./carriers/80x80/YI.png": 418256,
	"./carriers/80x80/YJ.png": 332075,
	"./carriers/80x80/YK.png": 441570,
	"./carriers/80x80/YL.png": 603293,
	"./carriers/80x80/YM.png": 382164,
	"./carriers/80x80/YN.png": 887279,
	"./carriers/80x80/YO.png": 822086,
	"./carriers/80x80/YP.png": 744017,
	"./carriers/80x80/YQ.png": 750152,
	"./carriers/80x80/YR.png": 87011,
	"./carriers/80x80/YS.png": 839258,
	"./carriers/80x80/YT.png": 663029,
	"./carriers/80x80/YU.png": 427116,
	"./carriers/80x80/YV.png": 329767,
	"./carriers/80x80/YW.png": 577278,
	"./carriers/80x80/YX.png": 606793,
	"./carriers/80x80/Z0.png": 802076,
	"./carriers/80x80/Z2.png": 114606,
	"./carriers/80x80/Z5.png": 32321,
	"./carriers/80x80/Z7.png": 156947,
	"./carriers/80x80/Z8.png": 861652,
	"./carriers/80x80/Z9.png": 294685,
	"./carriers/80x80/ZA.png": 272277,
	"./carriers/80x80/ZB.png": 104926,
	"./carriers/80x80/ZD.png": 31720,
	"./carriers/80x80/ZE.png": 445937,
	"./carriers/80x80/ZF.png": 515770,
	"./carriers/80x80/ZG.png": 833347,
	"./carriers/80x80/ZH.png": 375684,
	"./carriers/80x80/ZJ.png": 734006,
	"./carriers/80x80/ZK.png": 813983,
	"./carriers/80x80/ZL.png": 379008,
	"./carriers/80x80/ZM.png": 833833,
	"./carriers/80x80/ZN.png": 743122,
	"./carriers/80x80/ZO.png": 640987,
	"./carriers/80x80/ZP.png": 526396,
	"./carriers/80x80/ZQ.png": 539461,
	"./carriers/80x80/ZR.png": 667662,
	"./carriers/80x80/ZT.png": 535512,
	"./carriers/80x80/ZU.png": 503777,
	"./carriers/80x80/ZV.png": 554794,
	"./carriers/80x80/ZW.png": 710003,
	"./carriers/80x80/ZX.png": 84084,
	"./carriers/80x80/ZY.png": 305213,
	"./carriers/80x80/fallback.png": 441908,
	"./carriers/overrides/40x40/4U.png": 28085,
	"./carriers/overrides/40x40/9L.png": 366955,
	"./carriers/overrides/40x40/AV.png": 5929,
	"./carriers/overrides/40x40/GI.png": 93932,
	"./carriers/overrides/40x40/HJ.png": 532102,
	"./carriers/overrides/40x40/KE.png": 168364,
	"./carriers/overrides/40x40/MP.png": 616571,
	"./carriers/overrides/40x40/SL.png": 338005,
	"./carriers/overrides/40x40/TI.png": 600153,
	"./carriers/overrides/40x40/XN.png": 799186,
	"./carriers/overrides/80x80/4U.png": 537997,
	"./carriers/overrides/80x80/9L.png": 441859,
	"./carriers/overrides/80x80/AV.png": 505505,
	"./carriers/overrides/80x80/GI.png": 12212,
	"./carriers/overrides/80x80/HJ.png": 599966,
	"./carriers/overrides/80x80/KE.png": 877204,
	"./carriers/overrides/80x80/MP.png": 786819,
	"./carriers/overrides/80x80/SL.png": 951069,
	"./carriers/overrides/80x80/TI.png": 858753,
	"./carriers/overrides/80x80/XN.png": 669098
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(id => {
		return __webpack_require__.t(id, 1 | 16);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context */ 40709).then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 692963;
module.exports = webpackAsyncContext;